(function() {
  'use strict';

  angular
    .module('s5', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ngRoute', 'ui.bootstrap', 'toastr', 'duScroll']).value('duScrollBottomSpy', true);//, 'duScroll']);
    //angular.module('s5', ['duScroll']).value('duScrollBottomSpy', true);

})();

;
(function() {

  'use strict';

  angular.module('s5')
    .directive('spSimpleTest', spSimpleTest);

  spSimpleTest.$inject = ['$compile', '$templateRequest', '$http'];

  function spSimpleTest($compile, $templateRequest, $http) {
    var directive = {
      transclude: true,
      templateUrl: function(element, attrs) {
        return "app/components/sp-simple-test/" + (attrs.template || 'test') + ".html"
      },
      scope: {

      },
      controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
        //console.log('spSimpleTest');
      }],
      compile: function(element, attributes, transclude) {

        return {
          pre: function($scope, element, attrs, controller) {
            ////console.log(scope, element, attrs, controller);
          },
          post: function($scope, element, attrs, controller) {

            /* $scope.$on('answersInited', function(event) {
               //$('input, select').styler();
             });*/

            $scope.curQuestionNum = 0;
            $scope.resultScore = 0;
            $scope.resultNum = 0;
            $scope.result = null;
            // $scope.state = "waiting"; //result; //answered;
            $scope.answercheck = 0; //for ng-model
            $scope.lastCheckboxChNum = 0;
            $scope.state = "promo"; //course//result

            $scope.age = 0;
            $scope.selectedAge = 0;
            $scope.stringAge = "0";
            $scope.skintype = "";
            $scope.programnum = 1;
            $scope.selectedAge_string = '';

            $scope.mailSended = false;
            $scope.mailError = false;

            $scope.user = {
              mail: null
            };

            // $scope.scoreAr = [0, 0, 0, 0];
            // $scope.correct = 0;

            $scope.questions = [{
              'quest': "Твоя кожа…",
              'subhead': " (выбери один вариант)",
              'multi': false,
              'answers': [{
                text: "склонна к жирности, поры расширены, есть блеск",
                price: -1,
                skin: "norm"
              }, {
                text: "ровная, гладкая, без жирного блеска",
                price: 0,
                skin: "norm"
              }, {
                text: "сухая, бывает шелушение",
                price: 2,
                skin: "dry"
              }, {
                text: "тонкая, склонна к покраснениям, раздражению",
                price: 1,
                skin: "dry"
              }]
            }, {
              'quest': "Какой образ жизни ты ведешь?",
              'subhead': " (учти все подходящие фразы)",
              'multi': true,
              'answers': [{
                text: "много двигаешься и правильно питаешься",
                price: -1
              }, {
                text: "работаешь в кондиционируемом помещении",
                price: 1
              }, {
                text: "работаешь за компьютером больше 3 часов в день",
                price: 1
              }, {
                text: "куришь",
                price: 6
              }, {
                text: "практикуешь диеты",
                price: 2
              }, {
                text: "выпиваешь больше 2 алкогольных коктейлей в неделю",
                price: 3
              }, {
                text: "часто испытываешь стресс",
                price: 1
              }, {
                text: "любишь загорать или работаешь ежедневно на открытом воздухе",
                price: 4
              }, {
                text: "живешь в мегаполисе",
                price: 2
              }]
            }, {
              'quest': "Ты используешь крем для лица?",
              'answers': [{
                text: "да, каждый день",
                price: -2
              }, {
                text: "да, время от времени",
                price: -1
              }, {
                text: "нет",
                price: 0
              }]
            }, {
              'quest': "Как ты спишь?",
              'answers': [{
                text: "больше 7 часов в сутки",
                price: -3
              }, {
                text: "меньше 7 часов в сутки",
                price: 2
              }]
            }, {
              'quest': "Твои пищевые привычки:",
              'answers': [{
                text: "выпиваешь 1,5 л воды в день",
                price: -2
              }, {
                text: "принимаешь витамины, антиоксиданты, биологически активные добавки",
                price: -3
              }, {
                text: "ешь много сладкого (кусок торта или больше трех конфет каждый день)",
                price: 1
              }]
            }, {
              'quest': "Укажи свой возраст!",
              'answers': [{
                text: "от 26 до 35 лет",
                price: 0,
                age: 0,
              }, {
                text: "от 36 до 45 лет",
                price: 0,
                age: 1,
              }, {
                text: "от 46 до 55 лет",
                price: 0,
                age: 2,
              }, {
                text: "от 56 лет и старше",
                price: 0,
                age: 3,
              }]
            }];

            $scope.curQuestion = $scope.questions[$scope.curQuestionNum];

            $scope.results = [{
              head: "Всё по плану",
              text: "Тебе очень повезло – благодаря генетике, хорошим условиям жизни и наверняка своему здравому смыслу ты выглядишь прекрасно! В то же время старение невозможно остановить. Но можно значительно замедлить, если начать вовремя. Сейчас самый подходящий момент, чтобы заняться сохранением своих красоты и молодости. Изучи материалы нашего бьюти-расследования и приступай к правильному уходу.",
              link: "http://sp.cosmo.ru/api/common/share/go/593d2ac99e2004247ba1bbee15b32ca8"
            }, {
              head: "С опережением графика",
              text: "Плохая новость: твое лицо выглядит не так хорошо, как могло бы. Хорошая новость: это пока несложно исправить! Достаточно немного скорректировать свои привычки и обеспечить коже качественный уход. Для начала вооружись информацией: советы эксперта, опыт реальных девушек и наши секретные бьюти-материалы тебе помогут.",
              link: "http://sp.cosmo.ru/api/common/share/go/4a77b39871d7bf307427b5386a46f553"
            }, {
              head: "Критическое превышение скорости",
              text: "Не делай вид, что шокирована, – похоже, ты проживаешь жизнь на полную катушку и твоя кожа тоже живет (и стареет) в ускоренном темпе. Она устала! Ей нужен уход, а твоему организму – более здоровый образ жизни. Подумай, что тебе под силу изменить. Бросить курить? Заняться фитнесом? Больше спать? Только начни, и результаты не заставят себя ждать.",
              link: "http://sp.cosmo.ru/api/common/share/go/2a99d2bb4477efc42e390539efa98cdb"
            }];

            $scope.nextQuestion = function() {
              var index = $scope.lastCheckboxChNum;

              /*  $scope.age += $scope.questions[$scope.curQuestionNum].answers[index].price;
                //console.log('$scope.age'+$scope.age);

                //console.log('$scope.questions[$scope.curQuestionNum].answers[index].age' + $scope.questions[$scope.curQuestionNum].answers[index].age);

                if ($scope.questions[$scope.curQuestionNum].answers[index].age != undefined) {
                  $scope.selectedAge = $scope.questions[$scope.curQuestionNum].answers[index].age;
                }*/

              /*if ($scope.questions[$scope.curQuestionNum].answers[index].correct) {
                $scope.correct += 1;
              }*/
              // !! $scope.scoreAr[index] += 1; // !! тип: "больше вариантов А ""
              // !! $scope.resultScore += Number($scope.questions[$scope.curQuestionNum].answers[index].score); // тип: "разные очки за каждый вариант ответа"
              // $scope.state = "waiting";


              if ($scope.curQuestionNum >= $scope.questions.length - 1) {
                $scope.getResult();
                ////console.log('result');
              }
              else {

                $scope.curQuestionNum += 1;
                $scope.lastCheckboxChNum = 0;
                $scope.curQuestion = $scope.questions[$scope.curQuestionNum];
                //sendGAEvent('NextQuestion', 'Question ' + $scope.curQuestionNum, 'Вопрос ' + $scope.curQuestionNum);
              }
            }
            $scope.getResult = function() {
              //console.log('$scope.selectedAge'+$scope.selectedAge);
              $scope.state = "result";
              // !! var i = $scope.scoreAr.indexOf(Math.max.apply(Math, $scope.scoreAr)); // !! тип: "больше вариантов А ""
              // var i = $scope.correct;
              // $scope.result = $scope.results[i];
              //sendGAEvent('ShowResult', 'Result ' + (i + 1), 'Результат ' + (i + 1));
              $scope.resultScore = $scope.age;
              if ($scope.resultScore <= 5) {
                $scope.resultNum = 0;
                // $location.path("/test/result/0");
              }
              else if ($scope.resultScore > 5 && $scope.resultScore <= 15) {
                $scope.resultNum = 1;
                // $location.path("/test/result/1");
              }
              else {
                $scope.resultNum = 2;
                // $location.path("/test/result/2");
              }

              if ($scope.age < 0) {
                $scope.stringAge = $scope.age;
              }
              else {
                $scope.stringAge = "+" + $scope.age;
              }
              
              if($scope.selectedAge == 0){
                if($scope.skintype == "dry"){
                  $scope.programnum = 2;
                }else{
                  $scope.programnum = 1;
                }
              }else{
                $scope.programnum = $scope.selectedAge+2;
              }
             // console.log('$scope.programnum'+$scope.programnum);
              
              sendGAEvent('ShowResult_countedAge', 'CountedAge ' + $scope.stringAge, 'Расчитанный Возраст ' + $scope.stringAge);
              sendGAEvent('ShowResult_realAge', 'RealAge ' + $scope.selectedAge_string, 'Настоящий Возраст ' + $scope.selectedAge_string);
              sendGAEvent('ShowResult_programNum', 'ProgramNum ' + $scope.programnum, 'Номер Программы ' + $scope.programnum);

              //$scope.state = "result";
              //sendGAEvent('ShowResult', 'Age ' + $scope.resultScore, 'Возраст ' + $scope.resultScore); // !! тип: "разные очки за каждый вариант ответа"
              //  !! $location.path("/test/result/" + $scope.resultScore); // тип "количество правильных"
            }
            $scope.enableNext = function(index) { // !! есть кнопка далее
              ////console.log('enable');
              $scope.lastCheckboxChNum = index;
              //$scope.state = "answered";
            }
            $scope.showNext = function(index) {
              $scope.lastCheckboxChNum = index;
              $scope.nextQuestion();
            }
            $scope.startTest = function() {
              //$(".block_test").addClass("block_test_course");
              $scope.state = "course";
            }


            $scope.setActive = function(e) {
              var maxlength;
              if ($scope.questions[$scope.curQuestionNum].multi == true) {
                maxlength = $scope.questions[$scope.curQuestionNum].answers.length;
              }
              else {
                maxlength = 1;
                if (element.find(".active").length == maxlength) {
                  element.find(".active").toggleClass("active");
                }
              }
              angular.element(e.currentTarget).toggleClass("active");
              ////console.log(element.find(".active").length);
            }

            $scope.showNext = function() {
                //$scope.lastCheckboxChNum = index;
                $scope.checks = element.find('.test-question__option');
                var numAnswInQ = $scope.questions[$scope.curQuestionNum].answers.length;
                // var answcor = 0;
                for (var i = 0; i < numAnswInQ; i++) {
                  //var cornum = $scope.questions[$scope.curQuestionNum].correct[i];

                  if (angular.element($scope.checks[i]).hasClass("active")) {
                    //answcor += 1;
                    $scope.age += $scope.questions[$scope.curQuestionNum].answers[i].price;
                    if ($scope.questions[$scope.curQuestionNum].answers[i].age != undefined) {
                      $scope.selectedAge = $scope.questions[$scope.curQuestionNum].answers[i].age;
                      $scope.selectedAge_string = $scope.questions[$scope.curQuestionNum].answers[i].text;
                    }
                    if ($scope.questions[$scope.curQuestionNum].answers[i].skin != undefined) {
                      $scope.skintype = $scope.questions[$scope.curQuestionNum].answers[i].skin;
                    }
                  }


                  /* if (answcor == numAnswInQ) {
                     $scope.correct += 1;
                   }*/
                }
                $scope.nextQuestion();
              }
              ////console.log('$scope.state' + $scope.state)

            $scope.sendMail = function() {
              if ($scope.user.mail) {
                $scope.mailSended = true;
                $http({
                  method: 'GET',
                  url: 'http://sp.cosmo.ru/api/samoomolozhenie2015/send/program/'+$scope.programnum+'?email=' + $scope.user.mail //only@nahab.info
                }).then(function successCallback(response) {
                  $scope.mailError = false;
                  // this callback will be called asynchronously
                  // when the response is available
                  //console.log('succ-resp'+JSON.stringify(response));
                }, function errorCallback(response) {
                  //console.log('err-resp'+JSON.stringify(response));
                  $scope.mailSended = false;
                  $scope.mailError = true;
                  setTimeout(function() {
                      $scope.mailError = false;
                    }, 2000)
                    // called asynchronously if an error occurs
                    // or server returns response with an error status.
                });
              }
            }






          }
        }
      },

    };
    return directive;
  }

})();
;
(function() {

  'use strict';
  
  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spShare', spResultProfiles);

  spResultProfiles.$inject = ['$interval'];

  function spResultProfiles($interval) {
    var directive = {
        //transclude: true,
        templateUrl: function(element, attrs){
            return "app/components/sp-share/" + (attrs.template || 'share') + ".html"
        },
        replace: true,
        scope: {
            link: '@spShare',
            caption: '@',
            title: '@',
            description: '@',
            type: '@',
            theme: '@',
            services: '@',
            class: '@'
        },
        controller: ['$scope', '$element', '$attrs', '$rootScope', '$location', function ($scope, $element, $attrs, $rootScope, $location) {
            
            $scope.count = '+1';
            $scope.caption = $scope.caption || 'Поделиться';
            $element.find('.social_txt').on('click', function(e){
                $element.find('.social_txt').hide();
                $element.find('.social_btns').show();
            });
            
            $rootScope.shareId = $rootScope.shareId || 0;
            $scope.id = 'sp-share-'+$rootScope.shareId++;
            var share = $element.find('.social_btns').attr('id', $scope.id);
            
            $scope.init = function(){

                var buttons = angular.element('<div class="social_btns" style="display:none"></div>').attr('id', $scope.id);
                $element.find('.social_btns').replaceWith(buttons);
                $element.find('.social_txt').show();
                
                share.removeAttr('data-yasharelink').html('');
                //share.html('').removeData('yasharelink');
                //window.share = share;
                
                $scope.count = '+1';
                $scope.link = $scope.link || $location.absUrl();
                //$scope.title = $scope.title || null;
                //$scope.description = $scope.description || null;
                
                $scope.theme = $scope.theme || 'counter';
                $scope.type = $scope.type || 'small';
                $scope.servicesArray = $scope.services ? $scope.services.split(',') : ['vkontakte', 'facebook', 'twitter'];
                
                $scope.instance = new Ya.share({
                    //serviceSpecific: {twitter: {title: ''}},
                    element: $scope.id,
                    link: $scope.link,
                    title: $scope.title,
                    description: $scope.description,
                    theme: $scope.theme,
                    elementStyle: {
                      type: $scope.type,
                      quickServices: $scope.servicesArray
                    },
                    serviceSpecific: {
                      vkontakte: {
                        title: ' ',
                      },
                      twitter: {
                        //link: window.location.href
                      }
                    },
                    onready: function(instance) {
                      //instance.updateShareLink(link, title);
                      $interval.cancel($scope.interval);
                      $scope.interval = $interval(function(){
                        var count = 0;
                        angular.forEach($element.find('.b-share-counter'), function(value, index) {
                          count += parseInt(angular.element(value).text().replace(/ /g,'') || 0);
                        });
                        if(count>0){
                            $scope.count = count;
                            $interval.cancel($scope.interval);
                        }
                      }, 1000, 15);
                    },
                    onshare: function(network, instance){
                      $scope.count++;
                      //console.log(network, instance);
                    }
                });
            };

        }],
        //compile: function(element, attributes, transclude){
        compile: function(element, attributes){
            return {
                pre: function(scope, element, attrs, controller){
                    //console.log(scope, element, attrs, controller);
                },
                post: function(scope, element, attrs, controller){
                    
                    scope.$watchGroup(['link', 'title', 'description'], function(newValues, oldValues) {
                        //console.log(scope.id, newValues, oldValues);
                        scope.init();
                    });
                }
            }
        },
        
    };
    return directive;
  }
  
})();
;(function() {

  'use strict';
  
  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spScrollTo', spScrollTo);

  spScrollTo.$inject = ['$window', '$timeout'];

  function spScrollTo($window, $timeout) {
    var directive = {
        
        scope: {
            target: '@spScrollTo',
            scrollOffset: '@'
        },
        controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
            
            $element.on('click', function(e) {
                //e.preventDefault();
                $timeout(function(){
                    if($scope.target){
                        
                        if(parseInt($scope.target, 10) > 0){
                            var y = parseInt($scope.target, 10);
                            var sign = $scope.target.substr(0, 1);
                            if(sign == '+' || sign == '-'){
                                y += angular.element($window).scrollTop();
                            }
                            scrollTo(y);
                        } else {
                            var target = angular.element($scope.target);
                            if(target.length){
                                var y = target.offset().top + (parseInt($scope.scrollOffset, 10) || 0);
                                scrollTo(y);
                            }   
                        }
                    }
                }, 0);
            });
            
            function scrollTo(y){
                if($window.jQuery){
                    $window.jQuery('html,body').animate({scrollTop: y}, "slow");
                } else {
                    $window.scrollTo(0, y);
                }
            };
            
        }],
        
    };
    return directive;
  }
  
})();
;(function() {

    'use strict';
    
    angular.module('s5')
        .factory('ProfilesResults', Results);

    Results.$inject = ['$location', '$resource', '$cacheFactory', 'spSettings'];

    function Results($location, $resource, $cacheFactory, spSettings)
    {
        var baseUrl = [$location.protocol(), '://', $location.host(), '/api/', spSettings.id].join('');
        var url = [baseUrl, '/profiles/results/:id'].join('');
        var cache = $cacheFactory('$http-profiles-results', { capacity: 100 });
        
        var Results = {
            getShareLink: getShareLink,
            res: $resource(url, {},
                {
                    query:  {method:'JSONP', params: {callback: "JSON_CALLBACK"}, isArray:false, cache: cache},
                    get:  {method:'JSONP', params: {callback: "JSON_CALLBACK"}, isArray:false, cache: cache},
                }
            ),
            cache: cache
        };
        
        return Results;
        
        function getShareLink(id){
            return [baseUrl, '/profiles/share/results/', id].join('');
        }
    }

})();
;
(function() {

  'use strict';
  
  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spProfilesResults', Directive);

  Directive.$inject = [];

  function Directive() {
    var directive = {
        transclude: true,
        templateUrl: function(element, attrs){
            return "app/components/sp-profiles-results/results-" + (attrs.template || 'list') + ".html"
        },
        scope: {
            show: '@spProfilesResults',
            itemsPerPage: '@limit'
        },
        controller: ['$scope', '$element', '$attrs', '$rootScope', 'ProfilesResults', function ($scope, $element, $attrs, $rootScope, ProfilesResults) {
            
            $scope.results = [];
            $scope.profile = null;
            
            $scope.totalItems = 0;//64;
            $scope.itemsPerPage = $scope.itemsPerPage || 4; //итемов на страницу
            $scope.maxSize = 5; //макс видимых страниц в навигации
            
            //pagination link
            $scope.currentPage = 1;
            $scope.numPages = 0;
            
            $rootScope.$on('spForm:newResult', function (event, data) {
                ProfilesResults.cache.removeAll();
                $scope.updatePage(1);
            });
            
            $scope.pageChanged = function() {
                updateResults();
                //$log.log('Page changed to: ' + $scope.currentPage);
                //$location.search({page: $scope.currentPage});
            };
            
            $scope.showProfile = function(result) {
                //$scope.profileShareLink = [$location.protocol(), "://", $location.host(), '/api/laredoute2015/results/share/profiles/', result.ID].join('');
                $scope.profileShareLink = ProfilesResults.getShareLink(result.ID);
                $scope.profile = result;
            };
            
            $scope.updatePage = function(index) {
                $scope.currentPage = index;
                updateResults();
            };
            // 
            $scope.mediaMore = function() {
                $scope.currentPage++;
                $scope.loadMore = true;
                updateResults();
            };
            
            function updateResults() {
                
                var params = {
                    page: $scope.currentPage,
                    limit:  $scope.itemsPerPage
                };
                
                $scope.loading = $scope.loading || false;
                if(!$scope.loading){
                    
                    $scope.loading = true;
                    ProfilesResults.res.query(params,function(data){
                        $scope.loading = false;
                        if (!data.error) {
                            $scope.totalItems = data.nav.results_count || 0;
                            if($scope.loadMore){
                                $scope.loadMore = null;
                                Array.prototype.push.apply($scope.results, data.results || []);
                            } else {
                                $scope.results = angular.copy(data.results);
                            }
                        }
                    });
                }
            };
            
            updateResults();
            
            if($scope.show > 0){
                ProfilesResults.res.get({id: $scope.show},function(data){
                    if (!data.error && data.result) {
                        $scope.showProfile(data.result);
                    }
                });
            }
            		
        }],
        compile: function(element, attributes, transclude){
            
            return {
                pre: function(scope, element, attrs, controller){
                    //console.log(scope, element, attrs, controller);
                },
                post: function(scope, element, attrs, controller){
                    
                    transclude(scope, function(clone){
                      element.prepend(clone);
                    });
                    /*
                    $templateRequest("app/directives/instagram/"+scope.template+".html").then(function(html){
                        var template = angular.element(html);
                        element.append(template);
                        $compile(template)(scope);
                    });  
                    */
                }
            }
        },
        
    };
    return directive;
  }
  
})();
(function() {
  'use strict';

  angular
    .module('s5')
    .directive('spNavbar', spNavbar);

  /** @ngInject */
  function spNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sp-navbar/navbar.html',
      scope: {
          //creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($location, $scope) {
      var vm = this;
      
      vm.isActive = function (expr) {
          return (new RegExp(expr)).test($location.path())
      };
      
      $scope.isCollapsed = true;
      
    }
  }

})();

;(function() {

    'use strict';
    
    angular.module('s5')
        .factory('Instagram', Instagram);

    Instagram.$inject = ['$location', '$resource', '$cacheFactory'];

    function Instagram($location, $resource, $cacheFactory)
    {
        
        var url = [$location.protocol(), '://', $location.host(), '/api/common/instagram/tags/:tag/media/ngcache'].join('');
        var cache = $cacheFactory('$http-instagram', { capacity: 100 });
        
        var Instagram = {
            res: $resource(url, {},
                {
                    query:  {method:'JSONP', params: {callback: "JSON_CALLBACK"}, isArray:false, cache: cache},
                }
            ),
            cache: cache
        };
        
        return Instagram;
        
        
    }

})();
;
(function() {

  'use strict';
  
  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spInstagramList', spInstagramList);

  spInstagramList.$inject = [];

  function spInstagramList() {
    var directive = {
        transclude: true,
        templateUrl: function(element, attrs){
            return "app/components/sp-instagram/" + (attrs.template || 'list') + ".html"
        },
        scope: {
            tag: '@spInstagramList',
            count: '@limit',
            template: '@template',
        },
        controller: ['$scope', '$element', '$attrs', 'Instagram', function instagramListCtrl($scope, $element, $attrs, Instagram) {
            
            /*
            $scope.orders = {
                'time': {order: 'created_time', name: 'по дате'},
                'rating': {order: 'likes.count', name: 'по рейтингу'},
            };
            $scope.orderBy = 'time';
            */
            
            $scope.template = $scope.template || 'list';
            $scope.media = [];
            $scope.max_id = 0;
            $scope.loading = false;
            
            $scope.mediaMore = function() {
                updateResults();
            };
                
            function updateResults(){
                
                if($scope.tag){

                    var params = {
                        tag: $scope.tag,
                        max_id: $scope.max_id || 0,
                        count: $scope.count || 1
                    };
                    
                    $scope.loading = $scope.loading || false;
                    if(!$scope.loading){
                        
                        $scope.loading = true;
                        Instagram.res.query(params,function(data){
                            $scope.loading = false;
                            if (!data.error) {
                                $scope.max_id = data.response.max_id || 0;
                                Array.prototype.push.apply($scope.media, data.response.media || []);
                            }
                        });
                    }
                } else {
                    alert('instagram tag undefined');
                }
            };
            
            updateResults();
        			
        }],
        compile: function(element, attributes, transclude){
            
            return {
                pre: function(scope, element, attrs, controller){
                    //console.log(scope, element, attrs, controller);
                },
                post: function(scope, element, attrs, controller){
                    
                    transclude(scope, function(clone){
                      element.prepend(clone);
                    });
                    
                    /*$templateRequest("app/directives/instagram/"+scope.template+".html").then(function(html){
                        var template = angular.element(html);
                        element.append(template);
                        $compile(template)(scope);
                    });*/
                }
            }
        },
        
    };
    return directive;
  }
  
})();
;
(function() {

  'use strict';

  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spFullpage', Directive);
  
  /** @ngInject */
  function Directive($rootScope, $location) {
    var directive = {
      //transclude: true,
      scope: false,
      controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {

      }],
      compile: function(element, attributes) {

        return {
          pre: function(scope, element, attrs, controller) {
            //console.log(scope, element, attrs, controller);
          },
          post: function(scope, element, attrs, controller) {
            
            var search = $location.search();
            //window.l = $location;
            if(!search.full){
              console.log('!fp')
              return;
            }
            
            //alert('start');
            
            var fp_inited = false;

            var box = element.get(0);
           // checkBodyResizeClass();
            //$('.content_box').fullpage({
            if (window.innerWidth > 992 && window.innerHeight > 767) {
              initFP();
              $('.mini_logo').show();
            }else{
              $('.mini_logo').hide();
            }

            $(window).on('resize', function() {
             // checkBodyResizeClass();
              if (window.innerWidth > 992 && window.innerHeight > 767) {
                $('.mini_logo').show();
                if (fp_inited) {
                  $.fn.fullpage.reBuild();
                  $('.ff_block').css('height','768px');
                }
                else {
                  initFP();
                }
              }
              else {
                if (fp_inited) {
                $.fn.fullpage.destroy('all');
                }
                fp_inited = false;
                $('.mini_logo').hide();
              }
            });
            
            /*function checkBodyResizeClass(){
              if(window.innerWidth < 992){
                $('body').addClass('resize_width');
              }else{
                $('body').removeClass('resize_width');
              }
              
              if(window.innerHeight < 767){
                $('body').addClass('resize_height');
              }else{
                $('body').removeClass('resize_height');
              }
            }*/
            //$rootScope.on("showSlide", function (event, data) {
              scope.$on("showSlide", function (event, data) {
  console.log(data); // Данные, которые нам прислали
  $.fn.fullpage.moveTo(data.num);
});

            function initFP() {
              console.log('FP');
              $('.ff_block').css('height','768px');
              $(box).fullpage({
                anchors: ["_main", "_tipcosmo", "_about", "_steps", "_tipsite"],
                menu: '.page-indicators',
                sectionSelector: '.ff_block',
                lockAnchors: true,
                recordHistory: false
              });
              fp_inited = true;
              $('.mini_logo').show();
            }
          }
        }
      },

    };
    return directive;
  }

})();
;
(function() {

  'use strict';
  
  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spForm', spForm);

  spForm.$inject = ['$http', '$rootScope'];

  function spForm($http, $rootScope) {
    var directive = {
        transclude: true,
        templateUrl: function(element, attrs){
            return "app/components/sp-form/" + (attrs.template || 'form') + ".html"
        },
        scope: {
            formId: '@spForm'
        },
        controller: ['$scope', '$element', '$attrs', '$http', function($scope, $element, $attrs, $http) {
            
        }],
        compile: function(element, attributes, transclude){
            
            return {
                pre: function(scope, element, attrs, controller){
                    //console.log(scope, element, attrs, controller);
                },
                post: function(scope, element, attrs, controller){
                    /*
                    transclude(scope, function(clone){
                      element.prepend(clone);
                    });*/
                    
                    var $anketa = $('.spanketa');
                    var formUrl = 'http://' + document.location.hostname + "/api/common/forms/web/" + scope.formId;
                    
                    $('.anketa', $anketa).load( formUrl, function() {
                        $('form', $anketa).ajaxForm({
                            url: formUrl,
                            dataType:  'json',
                            beforeSubmit: function(arr, $form, options){
                                $(':submit', $anketa).attr('disabled', true);
                            },
                            success:   function processJson(data) {
                                $(':submit', $anketa).attr('disabled', false);
                                if(data.response){
                                    if(data.response.validation){
                                        $('.validation', $anketa).html('');
                                        $.each(data.response.validation, function( index, value ){
                                            $('.validation', $anketa).append($('<p/>').html(value));
                                        });
                                    }
                                    if(data.response.result_id){
                                        $('.validation, .anketa', $anketa).hide();
                                        $('.thanks', $anketa).show();
                                        $rootScope.$emit('spForm:newResult', {
                                            formId: scope.formId,
                                            resultId: data.response.result_id
                                        });
                                    }
                                }
                            },
                            error: function(){
                                alert('Ошибка сохранения результата');
                                //console.log('error', arguments);
                            }
                        }); 
                    });
                    
                }
            }
        },
        
    };
    return directive;
  }
  
})();
/*!
 * jQuery Form Plugin
 * version: 3.51.0-2014.06.20
 * Requires jQuery v1.5 or later
 * Copyright (c) 2014 M. Alsup
 * Examples and documentation at: http://malsup.com/jquery/form/
 * Project repository: https://github.com/malsup/form
 * Dual licensed under the MIT and GPL licenses.
 * https://github.com/malsup/form#copyright-and-license
 */
/*global ActiveXObject */

// AMD support
(function (factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        // using AMD; register as anon module
        define(['jquery'], factory);
    } else {
        // no AMD; invoke directly
        factory( (typeof(jQuery) != 'undefined') ? jQuery : window.Zepto );
    }
}

(function($) {
"use strict";

/*
    Usage Note:
    -----------
    Do not use both ajaxSubmit and ajaxForm on the same form.  These
    functions are mutually exclusive.  Use ajaxSubmit if you want
    to bind your own submit handler to the form.  For example,

    $(document).ready(function() {
        $('#myForm').on('submit', function(e) {
            e.preventDefault(); // <-- important
            $(this).ajaxSubmit({
                target: '#output'
            });
        });
    });

    Use ajaxForm when you want the plugin to manage all the event binding
    for you.  For example,

    $(document).ready(function() {
        $('#myForm').ajaxForm({
            target: '#output'
        });
    });

    You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
    form does not have to exist when you invoke ajaxForm:

    $('#myForm').ajaxForm({
        delegation: true,
        target: '#output'
    });

    When using ajaxForm, the ajaxSubmit function will be invoked for you
    at the appropriate time.
*/

/**
 * Feature detection
 */
var feature = {};
feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
feature.formdata = window.FormData !== undefined;

var hasProp = !!$.fn.prop;

// attr2 uses prop when it can but checks the return type for
// an expected string.  this accounts for the case where a form 
// contains inputs with names like "action" or "method"; in those
// cases "prop" returns the element
$.fn.attr2 = function() {
    if ( ! hasProp ) {
        return this.attr.apply(this, arguments);
    }
    var val = this.prop.apply(this, arguments);
    if ( ( val && val.jquery ) || typeof val === 'string' ) {
        return val;
    }
    return this.attr.apply(this, arguments);
};

/**
 * ajaxSubmit() provides a mechanism for immediately submitting
 * an HTML form using AJAX.
 */
$.fn.ajaxSubmit = function(options) {
    /*jshint scripturl:true */

    // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
    if (!this.length) {
        log('ajaxSubmit: skipping submit process - no element selected');
        return this;
    }

    var method, action, url, $form = this;

    if (typeof options == 'function') {
        options = { success: options };
    }
    else if ( options === undefined ) {
        options = {};
    }

    method = options.type || this.attr2('method');
    action = options.url  || this.attr2('action');

    url = (typeof action === 'string') ? $.trim(action) : '';
    url = url || window.location.href || '';
    if (url) {
        // clean url (don't include hash vaue)
        url = (url.match(/^([^#]+)/)||[])[1];
    }

    options = $.extend(true, {
        url:  url,
        success: $.ajaxSettings.success,
        type: method || $.ajaxSettings.type,
        iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
    }, options);

    // hook for manipulating the form data before it is extracted;
    // convenient for use with rich editors like tinyMCE or FCKEditor
    var veto = {};
    this.trigger('form-pre-serialize', [this, options, veto]);
    if (veto.veto) {
        log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
        return this;
    }

    // provide opportunity to alter form data before it is serialized
    if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
        log('ajaxSubmit: submit aborted via beforeSerialize callback');
        return this;
    }

    var traditional = options.traditional;
    if ( traditional === undefined ) {
        traditional = $.ajaxSettings.traditional;
    }

    var elements = [];
    var qx, a = this.formToArray(options.semantic, elements);
    if (options.data) {
        options.extraData = options.data;
        qx = $.param(options.data, traditional);
    }

    // give pre-submit callback an opportunity to abort the submit
    if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
        log('ajaxSubmit: submit aborted via beforeSubmit callback');
        return this;
    }

    // fire vetoable 'validate' event
    this.trigger('form-submit-validate', [a, this, options, veto]);
    if (veto.veto) {
        log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
        return this;
    }

    var q = $.param(a, traditional);
    if (qx) {
        q = ( q ? (q + '&' + qx) : qx );
    }
    if (options.type.toUpperCase() == 'GET') {
        options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
        options.data = null;  // data is null for 'get'
    }
    else {
        options.data = q; // data is the query string for 'post'
    }

    var callbacks = [];
    if (options.resetForm) {
        callbacks.push(function() { $form.resetForm(); });
    }
    if (options.clearForm) {
        callbacks.push(function() { $form.clearForm(options.includeHidden); });
    }

    // perform a load on the target only if dataType is not provided
    if (!options.dataType && options.target) {
        var oldSuccess = options.success || function(){};
        callbacks.push(function(data) {
            var fn = options.replaceTarget ? 'replaceWith' : 'html';
            $(options.target)[fn](data).each(oldSuccess, arguments);
        });
    }
    else if (options.success) {
        callbacks.push(options.success);
    }

    options.success = function(data, status, xhr) { // jQuery 1.4+ passes xhr as 3rd arg
        var context = options.context || this ;    // jQuery 1.4+ supports scope context
        for (var i=0, max=callbacks.length; i < max; i++) {
            callbacks[i].apply(context, [data, status, xhr || $form, $form]);
        }
    };

    if (options.error) {
        var oldError = options.error;
        options.error = function(xhr, status, error) {
            var context = options.context || this;
            oldError.apply(context, [xhr, status, error, $form]);
        };
    }

     if (options.complete) {
        var oldComplete = options.complete;
        options.complete = function(xhr, status) {
            var context = options.context || this;
            oldComplete.apply(context, [xhr, status, $form]);
        };
    }

    // are there files to upload?

    // [value] (issue #113), also see comment:
    // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
    var fileInputs = $('input[type=file]:enabled', this).filter(function() { return $(this).val() !== ''; });

    var hasFileInputs = fileInputs.length > 0;
    var mp = 'multipart/form-data';
    var multipart = ($form.attr('enctype') == mp || $form.attr('encoding') == mp);

    var fileAPI = feature.fileapi && feature.formdata;
    log("fileAPI :" + fileAPI);
    var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;

    var jqxhr;

    // options.iframe allows user to force iframe mode
    // 06-NOV-09: now defaulting to iframe mode if file input is detected
    if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
        // hack to fix Safari hang (thanks to Tim Molendijk for this)
        // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
        if (options.closeKeepAlive) {
            $.get(options.closeKeepAlive, function() {
                jqxhr = fileUploadIframe(a);
            });
        }
        else {
            jqxhr = fileUploadIframe(a);
        }
    }
    else if ((hasFileInputs || multipart) && fileAPI) {
        jqxhr = fileUploadXhr(a);
    }
    else {
        jqxhr = $.ajax(options);
    }

    $form.removeData('jqxhr').data('jqxhr', jqxhr);

    // clear element array
    for (var k=0; k < elements.length; k++) {
        elements[k] = null;
    }

    // fire 'notify' event
    this.trigger('form-submit-notify', [this, options]);
    return this;

    // utility fn for deep serialization
    function deepSerialize(extraData){
        var serialized = $.param(extraData, options.traditional).split('&');
        var len = serialized.length;
        var result = [];
        var i, part;
        for (i=0; i < len; i++) {
            // #252; undo param space replacement
            serialized[i] = serialized[i].replace(/\+/g,' ');
            part = serialized[i].split('=');
            // #278; use array instead of object storage, favoring array serializations
            result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
        }
        return result;
    }

     // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
    function fileUploadXhr(a) {
        var formdata = new FormData();

        for (var i=0; i < a.length; i++) {
            formdata.append(a[i].name, a[i].value);
        }

        if (options.extraData) {
            var serializedData = deepSerialize(options.extraData);
            for (i=0; i < serializedData.length; i++) {
                if (serializedData[i]) {
                    formdata.append(serializedData[i][0], serializedData[i][1]);
                }
            }
        }

        options.data = null;

        var s = $.extend(true, {}, $.ajaxSettings, options, {
            contentType: false,
            processData: false,
            cache: false,
            type: method || 'POST'
        });

        if (options.uploadProgress) {
            // workaround because jqXHR does not expose upload property
            s.xhr = function() {
                var xhr = $.ajaxSettings.xhr();
                if (xhr.upload) {
                    xhr.upload.addEventListener('progress', function(event) {
                        var percent = 0;
                        var position = event.loaded || event.position; /*event.position is deprecated*/
                        var total = event.total;
                        if (event.lengthComputable) {
                            percent = Math.ceil(position / total * 100);
                        }
                        options.uploadProgress(event, position, total, percent);
                    }, false);
                }
                return xhr;
            };
        }

        s.data = null;
        var beforeSend = s.beforeSend;
        s.beforeSend = function(xhr, o) {
            //Send FormData() provided by user
            if (options.formData) {
                o.data = options.formData;
            }
            else {
                o.data = formdata;
            }
            if(beforeSend) {
                beforeSend.call(this, xhr, o);
            }
        };
        return $.ajax(s);
    }

    // private function for handling file uploads (hat tip to YAHOO!)
    function fileUploadIframe(a) {
        var form = $form[0], el, i, s, g, id, $io, io, xhr, sub, n, timedOut, timeoutHandle;
        var deferred = $.Deferred();

        // #341
        deferred.abort = function(status) {
            xhr.abort(status);
        };

        if (a) {
            // ensure that every serialized input is still enabled
            for (i=0; i < elements.length; i++) {
                el = $(elements[i]);
                if ( hasProp ) {
                    el.prop('disabled', false);
                }
                else {
                    el.removeAttr('disabled');
                }
            }
        }

        s = $.extend(true, {}, $.ajaxSettings, options);
        s.context = s.context || s;
        id = 'jqFormIO' + (new Date().getTime());
        if (s.iframeTarget) {
            $io = $(s.iframeTarget);
            n = $io.attr2('name');
            if (!n) {
                $io.attr2('name', id);
            }
            else {
                id = n;
            }
        }
        else {
            $io = $('<iframe name="' + id + '" src="'+ s.iframeSrc +'" />');
            $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
        }
        io = $io[0];


        xhr = { // mock object
            aborted: 0,
            responseText: null,
            responseXML: null,
            status: 0,
            statusText: 'n/a',
            getAllResponseHeaders: function() {},
            getResponseHeader: function() {},
            setRequestHeader: function() {},
            abort: function(status) {
                var e = (status === 'timeout' ? 'timeout' : 'aborted');
                log('aborting upload... ' + e);
                this.aborted = 1;

                try { // #214, #257
                    if (io.contentWindow.document.execCommand) {
                        io.contentWindow.document.execCommand('Stop');
                    }
                }
                catch(ignore) {}

                $io.attr('src', s.iframeSrc); // abort op in progress
                xhr.error = e;
                if (s.error) {
                    s.error.call(s.context, xhr, e, status);
                }
                if (g) {
                    $.event.trigger("ajaxError", [xhr, s, e]);
                }
                if (s.complete) {
                    s.complete.call(s.context, xhr, e);
                }
            }
        };

        g = s.global;
        // trigger ajax global events so that activity/block indicators work like normal
        if (g && 0 === $.active++) {
            $.event.trigger("ajaxStart");
        }
        if (g) {
            $.event.trigger("ajaxSend", [xhr, s]);
        }

        if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
            if (s.global) {
                $.active--;
            }
            deferred.reject();
            return deferred;
        }
        if (xhr.aborted) {
            deferred.reject();
            return deferred;
        }

        // add submitting element to data if we know it
        sub = form.clk;
        if (sub) {
            n = sub.name;
            if (n && !sub.disabled) {
                s.extraData = s.extraData || {};
                s.extraData[n] = sub.value;
                if (sub.type == "image") {
                    s.extraData[n+'.x'] = form.clk_x;
                    s.extraData[n+'.y'] = form.clk_y;
                }
            }
        }

        var CLIENT_TIMEOUT_ABORT = 1;
        var SERVER_ABORT = 2;
                
        function getDoc(frame) {
            /* it looks like contentWindow or contentDocument do not
             * carry the protocol property in ie8, when running under ssl
             * frame.document is the only valid response document, since
             * the protocol is know but not on the other two objects. strange?
             * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
             */
            
            var doc = null;
            
            // IE8 cascading access check
            try {
                if (frame.contentWindow) {
                    doc = frame.contentWindow.document;
                }
            } catch(err) {
                // IE8 access denied under ssl & missing protocol
                log('cannot get iframe.contentWindow document: ' + err);
            }

            if (doc) { // successful getting content
                return doc;
            }

            try { // simply checking may throw in ie8 under ssl or mismatched protocol
                doc = frame.contentDocument ? frame.contentDocument : frame.document;
            } catch(err) {
                // last attempt
                log('cannot get iframe.contentDocument: ' + err);
                doc = frame.document;
            }
            return doc;
        }

        // Rails CSRF hack (thanks to Yvan Barthelemy)
        var csrf_token = $('meta[name=csrf-token]').attr('content');
        var csrf_param = $('meta[name=csrf-param]').attr('content');
        if (csrf_param && csrf_token) {
            s.extraData = s.extraData || {};
            s.extraData[csrf_param] = csrf_token;
        }

        // take a breath so that pending repaints get some cpu time before the upload starts
        function doSubmit() {
            // make sure form attrs are set
            var t = $form.attr2('target'), 
                a = $form.attr2('action'), 
                mp = 'multipart/form-data',
                et = $form.attr('enctype') || $form.attr('encoding') || mp;

            // update form attrs in IE friendly way
            form.setAttribute('target',id);
            if (!method || /post/i.test(method) ) {
                form.setAttribute('method', 'POST');
            }
            if (a != s.url) {
                form.setAttribute('action', s.url);
            }

            // ie borks in some cases when setting encoding
            if (! s.skipEncodingOverride && (!method || /post/i.test(method))) {
                $form.attr({
                    encoding: 'multipart/form-data',
                    enctype:  'multipart/form-data'
                });
            }

            // support timout
            if (s.timeout) {
                timeoutHandle = setTimeout(function() { timedOut = true; cb(CLIENT_TIMEOUT_ABORT); }, s.timeout);
            }

            // look for server aborts
            function checkState() {
                try {
                    var state = getDoc(io).readyState;
                    log('state = ' + state);
                    if (state && state.toLowerCase() == 'uninitialized') {
                        setTimeout(checkState,50);
                    }
                }
                catch(e) {
                    log('Server abort: ' , e, ' (', e.name, ')');
                    cb(SERVER_ABORT);
                    if (timeoutHandle) {
                        clearTimeout(timeoutHandle);
                    }
                    timeoutHandle = undefined;
                }
            }

            // add "extra" data to form if provided in options
            var extraInputs = [];
            try {
                if (s.extraData) {
                    for (var n in s.extraData) {
                        if (s.extraData.hasOwnProperty(n)) {
                           // if using the $.param format that allows for multiple values with the same name
                           if($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
                               extraInputs.push(
                               $('<input type="hidden" name="'+s.extraData[n].name+'">').val(s.extraData[n].value)
                                   .appendTo(form)[0]);
                           } else {
                               extraInputs.push(
                               $('<input type="hidden" name="'+n+'">').val(s.extraData[n])
                                   .appendTo(form)[0]);
                           }
                        }
                    }
                }

                if (!s.iframeTarget) {
                    // add iframe to doc and submit the form
                    $io.appendTo('body');
                }
                if (io.attachEvent) {
                    io.attachEvent('onload', cb);
                }
                else {
                    io.addEventListener('load', cb, false);
                }
                setTimeout(checkState,15);

                try {
                    form.submit();
                } catch(err) {
                    // just in case form has element with name/id of 'submit'
                    var submitFn = document.createElement('form').submit;
                    submitFn.apply(form);
                }
            }
            finally {
                // reset attrs and remove "extra" input elements
                form.setAttribute('action',a);
                form.setAttribute('enctype', et); // #380
                if(t) {
                    form.setAttribute('target', t);
                } else {
                    $form.removeAttr('target');
                }
                $(extraInputs).remove();
            }
        }

        if (s.forceSync) {
            doSubmit();
        }
        else {
            setTimeout(doSubmit, 10); // this lets dom updates render
        }

        var data, doc, domCheckCount = 50, callbackProcessed;

        function cb(e) {
            if (xhr.aborted || callbackProcessed) {
                return;
            }
            
            doc = getDoc(io);
            if(!doc) {
                log('cannot access response document');
                e = SERVER_ABORT;
            }
            if (e === CLIENT_TIMEOUT_ABORT && xhr) {
                xhr.abort('timeout');
                deferred.reject(xhr, 'timeout');
                return;
            }
            else if (e == SERVER_ABORT && xhr) {
                xhr.abort('server abort');
                deferred.reject(xhr, 'error', 'server abort');
                return;
            }

            if (!doc || doc.location.href == s.iframeSrc) {
                // response not received yet
                if (!timedOut) {
                    return;
                }
            }
            if (io.detachEvent) {
                io.detachEvent('onload', cb);
            }
            else {
                io.removeEventListener('load', cb, false);
            }

            var status = 'success', errMsg;
            try {
                if (timedOut) {
                    throw 'timeout';
                }

                var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
                log('isXml='+isXml);
                if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
                    if (--domCheckCount) {
                        // in some browsers (Opera) the iframe DOM is not always traversable when
                        // the onload callback fires, so we loop a bit to accommodate
                        log('requeing onLoad callback, DOM not available');
                        setTimeout(cb, 250);
                        return;
                    }
                    // let this fall through because server response could be an empty document
                    //log('Could not access iframe DOM after mutiple tries.');
                    //throw 'DOMException: not available';
                }

                //log('response detected');
                var docRoot = doc.body ? doc.body : doc.documentElement;
                xhr.responseText = docRoot ? docRoot.innerHTML : null;
                xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
                if (isXml) {
                    s.dataType = 'xml';
                }
                xhr.getResponseHeader = function(header){
                    var headers = {'content-type': s.dataType};
                    return headers[header.toLowerCase()];
                };
                // support for XHR 'status' & 'statusText' emulation :
                if (docRoot) {
                    xhr.status = Number( docRoot.getAttribute('status') ) || xhr.status;
                    xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
                }

                var dt = (s.dataType || '').toLowerCase();
                var scr = /(json|script|text)/.test(dt);
                if (scr || s.textarea) {
                    // see if user embedded response in textarea
                    var ta = doc.getElementsByTagName('textarea')[0];
                    if (ta) {
                        xhr.responseText = ta.value;
                        // support for XHR 'status' & 'statusText' emulation :
                        xhr.status = Number( ta.getAttribute('status') ) || xhr.status;
                        xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
                    }
                    else if (scr) {
                        // account for browsers injecting pre around json response
                        var pre = doc.getElementsByTagName('pre')[0];
                        var b = doc.getElementsByTagName('body')[0];
                        if (pre) {
                            xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
                        }
                        else if (b) {
                            xhr.responseText = b.textContent ? b.textContent : b.innerText;
                        }
                    }
                }
                else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
                    xhr.responseXML = toXml(xhr.responseText);
                }

                try {
                    data = httpData(xhr, dt, s);
                }
                catch (err) {
                    status = 'parsererror';
                    xhr.error = errMsg = (err || status);
                }
            }
            catch (err) {
                log('error caught: ',err);
                status = 'error';
                xhr.error = errMsg = (err || status);
            }

            if (xhr.aborted) {
                log('upload aborted');
                status = null;
            }

            if (xhr.status) { // we've set xhr.status
                status = (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) ? 'success' : 'error';
            }

            // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
            if (status === 'success') {
                if (s.success) {
                    s.success.call(s.context, data, 'success', xhr);
                }
                deferred.resolve(xhr.responseText, 'success', xhr);
                if (g) {
                    $.event.trigger("ajaxSuccess", [xhr, s]);
                }
            }
            else if (status) {
                if (errMsg === undefined) {
                    errMsg = xhr.statusText;
                }
                if (s.error) {
                    s.error.call(s.context, xhr, status, errMsg);
                }
                deferred.reject(xhr, 'error', errMsg);
                if (g) {
                    $.event.trigger("ajaxError", [xhr, s, errMsg]);
                }
            }

            if (g) {
                $.event.trigger("ajaxComplete", [xhr, s]);
            }

            if (g && ! --$.active) {
                $.event.trigger("ajaxStop");
            }

            if (s.complete) {
                s.complete.call(s.context, xhr, status);
            }

            callbackProcessed = true;
            if (s.timeout) {
                clearTimeout(timeoutHandle);
            }

            // clean up
            setTimeout(function() {
                if (!s.iframeTarget) {
                    $io.remove();
                }
                else { //adding else to clean up existing iframe response.
                    $io.attr('src', s.iframeSrc);
                }
                xhr.responseXML = null;
            }, 100);
        }

        var toXml = $.parseXML || function(s, doc) { // use parseXML if available (jQuery 1.5+)
            if (window.ActiveXObject) {
                doc = new ActiveXObject('Microsoft.XMLDOM');
                doc.async = 'false';
                doc.loadXML(s);
            }
            else {
                doc = (new DOMParser()).parseFromString(s, 'text/xml');
            }
            return (doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror') ? doc : null;
        };
        var parseJSON = $.parseJSON || function(s) {
            /*jslint evil:true */
            return window['eval']('(' + s + ')');
        };

        var httpData = function( xhr, type, s ) { // mostly lifted from jq1.4.4

            var ct = xhr.getResponseHeader('content-type') || '',
                xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
                data = xml ? xhr.responseXML : xhr.responseText;

            if (xml && data.documentElement.nodeName === 'parsererror') {
                if ($.error) {
                    $.error('parsererror');
                }
            }
            if (s && s.dataFilter) {
                data = s.dataFilter(data, type);
            }
            if (typeof data === 'string') {
                if (type === 'json' || !type && ct.indexOf('json') >= 0) {
                    data = parseJSON(data);
                } else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
                    $.globalEval(data);
                }
            }
            return data;
        };

        return deferred;
    }
};

/**
 * ajaxForm() provides a mechanism for fully automating form submission.
 *
 * The advantages of using this method instead of ajaxSubmit() are:
 *
 * 1: This method will include coordinates for <input type="image" /> elements (if the element
 *    is used to submit the form).
 * 2. This method will include the submit element's name/value data (for the element that was
 *    used to submit the form).
 * 3. This method binds the submit() method to the form for you.
 *
 * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
 * passes the options argument along after properly binding events for submit elements and
 * the form itself.
 */
$.fn.ajaxForm = function(options) {
    options = options || {};
    options.delegation = options.delegation && $.isFunction($.fn.on);

    // in jQuery 1.3+ we can fix mistakes with the ready state
    if (!options.delegation && this.length === 0) {
        var o = { s: this.selector, c: this.context };
        if (!$.isReady && o.s) {
            log('DOM not ready, queuing ajaxForm');
            $(function() {
                $(o.s,o.c).ajaxForm(options);
            });
            return this;
        }
        // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
        log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
        return this;
    }

    if ( options.delegation ) {
        $(document)
            .off('submit.form-plugin', this.selector, doAjaxSubmit)
            .off('click.form-plugin', this.selector, captureSubmittingElement)
            .on('submit.form-plugin', this.selector, options, doAjaxSubmit)
            .on('click.form-plugin', this.selector, options, captureSubmittingElement);
        return this;
    }

    return this.ajaxFormUnbind()
        .bind('submit.form-plugin', options, doAjaxSubmit)
        .bind('click.form-plugin', options, captureSubmittingElement);
};

// private event handlers
function doAjaxSubmit(e) {
    /*jshint validthis:true */
    var options = e.data;
    if (!e.isDefaultPrevented()) { // if event has been canceled, don't proceed
        e.preventDefault();
        $(e.target).ajaxSubmit(options); // #365
    }
}

function captureSubmittingElement(e) {
    /*jshint validthis:true */
    var target = e.target;
    var $el = $(target);
    if (!($el.is("[type=submit],[type=image]"))) {
        // is this a child element of the submit el?  (ex: a span within a button)
        var t = $el.closest('[type=submit]');
        if (t.length === 0) {
            return;
        }
        target = t[0];
    }
    var form = this;
    form.clk = target;
    if (target.type == 'image') {
        if (e.offsetX !== undefined) {
            form.clk_x = e.offsetX;
            form.clk_y = e.offsetY;
        } else if (typeof $.fn.offset == 'function') {
            var offset = $el.offset();
            form.clk_x = e.pageX - offset.left;
            form.clk_y = e.pageY - offset.top;
        } else {
            form.clk_x = e.pageX - target.offsetLeft;
            form.clk_y = e.pageY - target.offsetTop;
        }
    }
    // clear form vars
    setTimeout(function() { form.clk = form.clk_x = form.clk_y = null; }, 100);
}


// ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
$.fn.ajaxFormUnbind = function() {
    return this.unbind('submit.form-plugin click.form-plugin');
};

/**
 * formToArray() gathers form element data into an array of objects that can
 * be passed to any of the following ajax functions: $.get, $.post, or load.
 * Each object in the array has both a 'name' and 'value' property.  An example of
 * an array for a simple login form might be:
 *
 * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
 *
 * It is this array that is passed to pre-submit callback functions provided to the
 * ajaxSubmit() and ajaxForm() methods.
 */
$.fn.formToArray = function(semantic, elements) {
    var a = [];
    if (this.length === 0) {
        return a;
    }

    var form = this[0];
    var formId = this.attr('id');
    var els = semantic ? form.getElementsByTagName('*') : form.elements;
    var els2;

    if (els && !/MSIE [678]/.test(navigator.userAgent)) { // #390
        els = $(els).get();  // convert to standard array
    }

    // #386; account for inputs outside the form which use the 'form' attribute
    if ( formId ) {
        els2 = $(':input[form="' + formId + '"]').get(); // hat tip @thet
        if ( els2.length ) {
            els = (els || []).concat(els2);
        }
    }

    if (!els || !els.length) {
        return a;
    }

    var i,j,n,v,el,max,jmax;
    for(i=0, max=els.length; i < max; i++) {
        el = els[i];
        n = el.name;
        if (!n || el.disabled) {
            continue;
        }

        if (semantic && form.clk && el.type == "image") {
            // handle image inputs on the fly when semantic == true
            if(form.clk == el) {
                a.push({name: n, value: $(el).val(), type: el.type });
                a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
            }
            continue;
        }

        v = $.fieldValue(el, true);
        if (v && v.constructor == Array) {
            if (elements) {
                elements.push(el);
            }
            for(j=0, jmax=v.length; j < jmax; j++) {
                a.push({name: n, value: v[j]});
            }
        }
        else if (feature.fileapi && el.type == 'file') {
            if (elements) {
                elements.push(el);
            }
            var files = el.files;
            if (files.length) {
                for (j=0; j < files.length; j++) {
                    a.push({name: n, value: files[j], type: el.type});
                }
            }
            else {
                // #180
                a.push({ name: n, value: '', type: el.type });
            }
        }
        else if (v !== null && typeof v != 'undefined') {
            if (elements) {
                elements.push(el);
            }
            a.push({name: n, value: v, type: el.type, required: el.required});
        }
    }

    if (!semantic && form.clk) {
        // input type=='image' are not found in elements array! handle it here
        var $input = $(form.clk), input = $input[0];
        n = input.name;
        if (n && !input.disabled && input.type == 'image') {
            a.push({name: n, value: $input.val()});
            a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
        }
    }
    return a;
};

/**
 * Serializes form data into a 'submittable' string. This method will return a string
 * in the format: name1=value1&amp;name2=value2
 */
$.fn.formSerialize = function(semantic) {
    //hand off to jQuery.param for proper encoding
    return $.param(this.formToArray(semantic));
};

/**
 * Serializes all field elements in the jQuery object into a query string.
 * This method will return a string in the format: name1=value1&amp;name2=value2
 */
$.fn.fieldSerialize = function(successful) {
    var a = [];
    this.each(function() {
        var n = this.name;
        if (!n) {
            return;
        }
        var v = $.fieldValue(this, successful);
        if (v && v.constructor == Array) {
            for (var i=0,max=v.length; i < max; i++) {
                a.push({name: n, value: v[i]});
            }
        }
        else if (v !== null && typeof v != 'undefined') {
            a.push({name: this.name, value: v});
        }
    });
    //hand off to jQuery.param for proper encoding
    return $.param(a);
};

/**
 * Returns the value(s) of the element in the matched set.  For example, consider the following form:
 *
 *  <form><fieldset>
 *      <input name="A" type="text" />
 *      <input name="A" type="text" />
 *      <input name="B" type="checkbox" value="B1" />
 *      <input name="B" type="checkbox" value="B2"/>
 *      <input name="C" type="radio" value="C1" />
 *      <input name="C" type="radio" value="C2" />
 *  </fieldset></form>
 *
 *  var v = $('input[type=text]').fieldValue();
 *  // if no values are entered into the text inputs
 *  v == ['','']
 *  // if values entered into the text inputs are 'foo' and 'bar'
 *  v == ['foo','bar']
 *
 *  var v = $('input[type=checkbox]').fieldValue();
 *  // if neither checkbox is checked
 *  v === undefined
 *  // if both checkboxes are checked
 *  v == ['B1', 'B2']
 *
 *  var v = $('input[type=radio]').fieldValue();
 *  // if neither radio is checked
 *  v === undefined
 *  // if first radio is checked
 *  v == ['C1']
 *
 * The successful argument controls whether or not the field element must be 'successful'
 * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
 * The default value of the successful argument is true.  If this value is false the value(s)
 * for each element is returned.
 *
 * Note: This method *always* returns an array.  If no valid value can be determined the
 *    array will be empty, otherwise it will contain one or more values.
 */
$.fn.fieldValue = function(successful) {
    for (var val=[], i=0, max=this.length; i < max; i++) {
        var el = this[i];
        var v = $.fieldValue(el, successful);
        if (v === null || typeof v == 'undefined' || (v.constructor == Array && !v.length)) {
            continue;
        }
        if (v.constructor == Array) {
            $.merge(val, v);
        }
        else {
            val.push(v);
        }
    }
    return val;
};

/**
 * Returns the value of the field element.
 */
$.fieldValue = function(el, successful) {
    var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
    if (successful === undefined) {
        successful = true;
    }

    if (successful && (!n || el.disabled || t == 'reset' || t == 'button' ||
        (t == 'checkbox' || t == 'radio') && !el.checked ||
        (t == 'submit' || t == 'image') && el.form && el.form.clk != el ||
        tag == 'select' && el.selectedIndex == -1)) {
            return null;
    }

    if (tag == 'select') {
        var index = el.selectedIndex;
        if (index < 0) {
            return null;
        }
        var a = [], ops = el.options;
        var one = (t == 'select-one');
        var max = (one ? index+1 : ops.length);
        for(var i=(one ? index : 0); i < max; i++) {
            var op = ops[i];
            if (op.selected) {
                var v = op.value;
                if (!v) { // extra pain for IE...
                    v = (op.attributes && op.attributes.value && !(op.attributes.value.specified)) ? op.text : op.value;
                }
                if (one) {
                    return v;
                }
                a.push(v);
            }
        }
        return a;
    }
    return $(el).val();
};

/**
 * Clears the form data.  Takes the following actions on the form's input fields:
 *  - input text fields will have their 'value' property set to the empty string
 *  - select elements will have their 'selectedIndex' property set to -1
 *  - checkbox and radio inputs will have their 'checked' property set to false
 *  - inputs of type submit, button, reset, and hidden will *not* be effected
 *  - button elements will *not* be effected
 */
$.fn.clearForm = function(includeHidden) {
    return this.each(function() {
        $('input,select,textarea', this).clearFields(includeHidden);
    });
};

/**
 * Clears the selected form elements.
 */
$.fn.clearFields = $.fn.clearInputs = function(includeHidden) {
    var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
    return this.each(function() {
        var t = this.type, tag = this.tagName.toLowerCase();
        if (re.test(t) || tag == 'textarea') {
            this.value = '';
        }
        else if (t == 'checkbox' || t == 'radio') {
            this.checked = false;
        }
        else if (tag == 'select') {
            this.selectedIndex = -1;
        }
        else if (t == "file") {
            if (/MSIE/.test(navigator.userAgent)) {
                $(this).replaceWith($(this).clone(true));
            } else {
                $(this).val('');
            }
        }
        else if (includeHidden) {
            // includeHidden can be the value true, or it can be a selector string
            // indicating a special test; for example:
            //  $('#myForm').clearForm('.special:hidden')
            // the above would clean hidden inputs that have the class of 'special'
            if ( (includeHidden === true && /hidden/.test(t)) ||
                 (typeof includeHidden == 'string' && $(this).is(includeHidden)) ) {
                this.value = '';
            }
        }
    });
};

/**
 * Resets the form data.  Causes all form elements to be reset to their original value.
 */
$.fn.resetForm = function() {
    return this.each(function() {
        // guard against an input with the name of 'reset'
        // note that IE reports the reset function as an 'object'
        if (typeof this.reset == 'function' || (typeof this.reset == 'object' && !this.reset.nodeType)) {
            this.reset();
        }
    });
};

/**
 * Enables or disables any matching elements.
 */
$.fn.enable = function(b) {
    if (b === undefined) {
        b = true;
    }
    return this.each(function() {
        this.disabled = !b;
    });
};

/**
 * Checks/unchecks any matching checkboxes or radio buttons and
 * selects/deselects and matching option elements.
 */
$.fn.selected = function(select) {
    if (select === undefined) {
        select = true;
    }
    return this.each(function() {
        var t = this.type;
        if (t == 'checkbox' || t == 'radio') {
            this.checked = select;
        }
        else if (this.tagName.toLowerCase() == 'option') {
            var $sel = $(this).parent('select');
            if (select && $sel[0] && $sel[0].type == 'select-one') {
                // deselect all other options
                $sel.find('option').selected(false);
            }
            this.selected = select;
        }
    });
};

// expose debug var
$.fn.ajaxSubmit.debug = false;

// helper fn for console logging
function log() {
    if (!$.fn.ajaxSubmit.debug) {
        return;
    }
    var msg = '[jquery.form] ' + Array.prototype.join.call(arguments,'');
    if (window.console && window.console.log) {
        window.console.log(msg);
    }
    else if (window.opera && window.opera.postError) {
        window.opera.postError(msg);
    }
}

}));
(function() {
  'use strict';

  angular
    .module('s5')
    .directive('spFooter', spFooter);

  /** @ngInject */
  function spFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sp-footer/footer.html',
      scope: {},
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController($location) {
      var vm = this;
      
      vm.openFooter = false;
      
    }
  }

})();

;(function() {

    'use strict';
    
    angular.module('s5')
        .factory('ExpertsResults', Results);

    Results.$inject = ['$location', '$resource', '$cacheFactory', 'spSettings'];

    function Results($location, $resource, $cacheFactory, spSettings)
    {
        var baseUrl = [$location.protocol(), '://', $location.host(), '/api/', spSettings.id].join('');
        var url = [baseUrl, '/experts/results/:id'].join('');
        var cache = $cacheFactory('$http-experts-results', { capacity: 100 });
        
        var Results = {
            getShareLink: getShareLink,
            res: $resource(url, {},
                {
                    query:  {method:'JSONP', params: {callback: "JSON_CALLBACK"}, isArray:false, cache: cache},
                    get:  {method:'JSONP', params: {callback: "JSON_CALLBACK"}, isArray:false, cache: cache},
                }
            ),
            cache: cache
        };
        
        return Results;
        
        function getShareLink(id){
            return [baseUrl, '/experts/share/results/', id].join('');
        }
    }

})();
;
(function() {

  'use strict';
  
  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spExpertsResults', Directive);

  Directive.$inject = [];

  function Directive() {
    var directive = {
        transclude: true,
        templateUrl: function(element, attrs){
            return "app/components/sp-experts-results/results-" + (attrs.template || 'list') + ".html"
        },
        scope: {
            show: '@spExpertsResults',
            itemsPerPage: '@limit'
        },
        controller: ['$scope', '$element', '$attrs', '$rootScope', 'ExpertsResults', function ($scope, $element, $attrs, $rootScope, ExpertsResults) {
            
            $scope.results = [];
            $scope.result = null;
            
            $scope.totalItems = 0;//64;
            $scope.itemsPerPage = $scope.itemsPerPage || 20; //итемов на страницу
            $scope.maxSize = 5; //макс видимых страниц в навигации
            
            //pagination link
            $scope.currentPage = 1;
            $scope.numPages = 0;
            
            $rootScope.$on('spForm:newResult', function (event, data) {
                ExpertsResults.cache.removeAll();
                $scope.updatePage(1);
            });
            
            $scope.pageChanged = function() {
                updateResults();
                //$log.log('Page changed to: ' + $scope.currentPage);
                //$location.search({page: $scope.currentPage});
            };
            
            $scope.showResult = function(result) {
                $scope.resultShareLink = ExpertsResults.getShareLink(result.ID);
                $scope.result = result;
            };
            
            $scope.updatePage = function(index) {
                $scope.currentPage = index;
                updateResults();
            };
            // 
            $scope.mediaMore = function() {
                $scope.currentPage++;
                $scope.loadMore = true;
                updateResults();
            };
            
            function updateResults() {
                
                var params = {
                    page: $scope.currentPage,
                    limit:  $scope.itemsPerPage
                };
                
                $scope.loading = $scope.loading || false;
                if(!$scope.loading){
                    
                    $scope.loading = true;
                    ExpertsResults.res.query(params,function(data){
                        $scope.loading = false;
                        if (!data.error) {
                            $scope.totalItems = data.nav.results_count || 0;
                            if($scope.loadMore){
                                $scope.loadMore = null;
                                Array.prototype.push.apply($scope.results, data.results || []);
                            } else {
                                $scope.results = angular.copy(data.results);
                            }
                        }
                    });
                }
            };
            
            updateResults();
            
            if($scope.show > 0){
                ExpertsResults.res.get({id: $scope.show},function(data){
                    if (!data.error && data.result) {
                        $scope.showProfile(data.result);
                    }
                });
            }
            		
        }],
        compile: function(element, attributes, transclude){
            
            return {
                pre: function(scope, element, attrs, controller){
                    //console.log(scope, element, attrs, controller);
                },
                post: function(scope, element, attrs, controller){
                    
                    transclude(scope, function(clone){
                      element.prepend(clone);
                    });
                    /*
                    $templateRequest("app/directives/instagram/"+scope.template+".html").then(function(html){
                        var template = angular.element(html);
                        element.append(template);
                        $compile(template)(scope);
                    });  
                    */
                }
            }
        },
        
    };
    return directive;
  }
  
})();
;
(function() {

  'use strict';
  
  angular.module('s5')
    .directive('spCountdown', spCountdown);

  spCountdown.$inject = [];

  function spCountdown() {
    var directive = {
        transclude: true,
        /*templateUrl: function(element, attrs){
            return "app/directives/sp-form/" + (attrs.template || 'form') + ".html"
        },*/
        scope: {
            happyEnd: '@spCountdown'
        },
        controller: ['$scope', '$element', '$attrs', '$interval', function($scope, $element, $attrs, $interval) {
            $scope.countdown = {};
      
            $scope.startDate = new Date();
            if($scope.happyEnd){
                var bits = $scope.happyEnd.split(/\D/);
                $scope.endDate = new Date(bits[0], --bits[1], bits[2], bits[3] || 0, bits[4] || 0, bits[5] || 0, 0);
            } else {
                $scope.endDate = $scope.startDate;
            }
            
            $scope.counter = $scope.endDate.getTime() - $scope.startDate.getTime();
            $scope.counter = ($scope.counter - $scope.counter % 1000) / 1000;
            
            var intervalID = $interval(function(){
              $scope.counter--;
              if( $scope.counter > 0 ){
                  updateTimer($scope.counter);
              }else{
                  updateTimer(0);
                  $interval.cancel(intervalID);
              }
            }, 1000, $scope.counter);
            
            function declOfNum(number, titles) {
                var cases = [2, 0, 1, 1, 1, 2];
                return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
            }
            
            function updateTimer( count ){
              var timer = new Object();
              timer.seconds = count % 60; count = (count - timer.seconds) / 60;
              timer.minutes = count % 60; count = (count - timer.minutes) / 60;
              timer.hours = count % 24;
              timer.days = (count - timer.hours) / 24;
              $scope.countdown = {
                timer: timer,
                lang: {
                  seconds: declOfNum(timer.seconds, ['секунда', 'секунды', 'секунд']),
                  minutes: declOfNum(timer.minutes, ['минута', 'минуты', 'минут']),
                  hours: declOfNum(timer.hours, ['час', 'часа', 'часов']),
                  days: declOfNum(timer.days, ['день', 'дня', 'дней']),
                }
              };
            }
            
        }],
        compile: function(element, attributes, transclude){
            
            return {
                pre: function(scope, element, attrs, controller){
                },
                post: function(scope, element, attrs, controller){
                    transclude(scope, function(clone){
                      element.prepend(clone);
                    });
                }
            }
        },
        
    };
    return directive;
  }
  
})();
;
(function() {

  'use strict';

  angular.module('s5')
    .directive('fullscreenizer', fullscreenizer);

  fullscreenizer.$inject = ['$compile', '$timeout'];

  function fullscreenizer($compile) {
    var directive = {
      transclude: true,
      template: '<div class="wrapper">' +
                    '<ng-transclude></ng-transclude>' +
                  '</div>',
      scope: {},//false ,//{      },
      controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
        //console.log('fs');
      }],
      compile: function(element, attributes, transclude) {

        return {
          pre: function($scope, element, attrs, controller) {
            ////console.log(scope, element, attrs, controller);
          },
          post: function($scope, element, attrs, controller) {
              
              
            var ratio = 16/9;
    
  //  var $wrapper = angular.element(".videoWrapper");
    var $wrapper = element.find(".wrapper");
   // var $player = $wrapper.find("iframe");
    
    $wrapper.css({'overflow': 'hidden', 'position': 'absolute',
    //'z-index': '1',
    'width': '100%', 'height': '100%'});
    
    $scope.resizeElement = function(){
      console.log('res');
      var $player = $wrapper.find("iframe,img").eq(0);
     // var $player = $wrapper.first('iframe,img');
      var width = $wrapper.width(),
           pWidth, // player width, to be defined
           height = $wrapper.height(),
           pHeight
      
     if (width / ratio < height) { // if new video height < window height (gap underneath)
            pWidth = Math.ceil(height * ratio); // get new player width
            $player.width(pWidth).height(height).css({left: (width - pWidth) / 2, top: 0}); // player width is greater, offset left; reset top
        } else { // new video width < window width (gap to right)
            pHeight = Math.ceil(width / ratio); // get new player height
            $player.width(width).height(pHeight).css({left: 0, top: (height - pHeight) / 2}); // player height is greater, offset top; reset left
        }
    }
    $(window).on('resize', function(){$scope.resizeElement()});
   // setTimeout(function(){$scope.resizeElement()}, 1000)
    //$timeout(function(){$scope.resizeElement()}, 1000); //ReferenceError: $timeout is not defined
    $scope.$on('ybgReady', function(e,d){$scope.resizeElement(); console.log('ybgReady');})          
              
              
              
              
              
              
          }
        }
      },

    };
    return directive;
  }

})();
;
(function() {

  'use strict';

  //https://docs.angularjs.org/api/ng/service/$compile

  angular.module('s5')
    .directive('spPagechange', Directive);

  /** @ngInject */
  function Directive($rootScope, $window, $document, $timeout) {
    var directive = {
      //transclude: true,
      scope: {
        pagePrev: '@',
        pageNext: '@',
        pageChange: '=spPagechange'
      },
      compile: function(element, attributes) {

        return {
          pre: function(scope, element, attrs, controller) {
            //console.log(scope, element, attrs, controller);
          },
          post: function(scope, element, attrs, controller) {

            angular.element('body').css({
              'background-color': '#000'
            });
            var el = element.get(0);
            //console.log(scope);

            function pageShow(type) {
              if (type == 'prev') {
                scope.pagePrev && scope.pageChange && scope.pageChange(scope.pagePrev);
              }
              else if (type == 'next') {
                scope.pageNext && scope.pageChange && scope.pageChange(scope.pageNext);
              }
              return true;
            }

            var threshold = {
              up: 0,
              down: 0,
              max: 3
            };

            function pageMoveHandler(deltaY) {
              // angular.element($window).scrollTop()+angular.element($window).height() == angular.element($document).height();
              var hasScroll = el.scrollHeight > el.clientHeight;
              var isTop = (element.scrollTop() == 0);
              var isBottom = (element.scrollTop() + el.clientHeight >= el.scrollHeight);
              var direction = deltaY > 0 ? 'up' : 'down';
              //alert( JSON.stringify([el.scrollHeight, el.clientHeight, element.scrollTop()]) );
              console.log(deltaY, el.scrollHeight, el.clientHeight, el.offsetHeight, element.height(), {
                hasScroll: hasScroll,
                isTop: isTop,
                isBottom: isBottom
              });
              //alert([deltaY]);
              if (direction == 'up') {
                if (hasScroll && isTop || !hasScroll) {
                  threshold.up++;
                  threshold.down = 0;
                  if (threshold.up > threshold.max) {
                    pageShow('prev');
                    threshold.up = 0;
                  }
                }
              }
              else if (direction == 'down') {
                if (hasScroll && isBottom || !hasScroll) {
                  threshold.up = 0;
                  threshold.down++;
                  if (threshold.down > threshold.max) {
                    pageShow('next');
                    threshold.down = 0;
                  }
                }
              }
            }

            Hamster(el).wheel(function(event, delta, deltaX, deltaY) {
              pageMoveHandler(deltaY);
            });

            window.h = $(el).hammer()
              .on('panup', function(event) {
                event.stopPropagation();
                threshold = {
                  up: 0,
                  down: 0,
                  max: 0
                };
                element.scrollTop(element.scrollTop() - event.gesture.deltaY / 10);
                pageMoveHandler(event.gesture.deltaY);

              }).on('pandown', function(event) {
                event.stopPropagation();
                threshold = {
                  up: 0,
                  down: 0,
                  max: 0
                };
                element.scrollTop(element.scrollTop() - event.gesture.deltaY / 10);
                pageMoveHandler(event.gesture.deltaY);
              })
              .data('hammer')
              .get('swipe')
              .set({
                direction: Hammer.DIRECTION_VERTICAL,
                preventDefault: false
              }); //включаются обработчки но перестает скролить)


            /* var initialY = null,
                 previousY = null,
                 bindScrollEvent = function(e){
                     previousY = initialY = e.touches[0].clientY;

                     // Pull to reload won't be activated if the element is not initially at scrollTop === 0
                     if(element[0].scrollTop <= 0){
                         element.on("touchmove", blockScroll);
                     }
                 },
                 blockScroll = function(e){
                     if(previousY && previousY < e.touches[0].clientY){ //Scrolling up
                         e.preventDefault();
                     }
                     else if(initialY >= e.touches[0].clientY){ //Scrolling down
                         //As soon as you scroll down, there is no risk of pulling to reload
                         element.off("touchmove", blockScroll);
                     }
                     previousY = e.touches[0].clientY;
                 },
                 unbindScrollEvent = function(e){
                     element.off("touchmove", blockScroll);
                 };
             element.on("touchstart", bindScrollEvent);
             element.on("touchend", unbindScrollEvent);*/

            var maybePreventPullToRefresh = false;
            var lastTouchY = 0;
            var touchstartHandler = function(e) {
              if (e.touches.length != 1) return;
              lastTouchY = e.touches[0].clientY;
              // Pull-to-refresh will only trigger if the scroll begins when the
              // document's Y offset is zero.
              maybePreventPullToRefresh =
                preventPullToRefreshCheckbox.checked &&
                window.pageYOffset == 0;
            }

            var touchmoveHandler = function(e) {
              var touchY = e.touches[0].clientY;
              var touchYDelta = touchY - lastTouchY;
              lastTouchY = touchY;

             // if (maybePreventPullToRefresh) {
                // To suppress pull-to-refresh it is sufficient to preventDefault the
                // first overscrolling touchmove.
                maybePreventPullToRefresh = false;
                if (touchYDelta > 0) {
                  e.preventDefault();
                  return;
                }
            //  }

              /* if (preventScrollCheckbox.checked) {
                 e.preventDefault();
                 return;
               }*/

              // if (preventOverscrollGlowCheckbox.checked) {
              if (window.pageYOffset == 0 && touchYDelta > 0) {
                e.preventDefault();
                return;
              }
              // }
            }

            document.addEventListener('touchstart', touchstartHandler, false);
            document.addEventListener('touchmove', touchmoveHandler, false);

          }
        }
      },

    };
    return directive;
  }

})();
(function() {
  'use strict';

  angular
    .module('s5')
    .controller('PageController', Controller);

  /** @ngInject */
  function Controller($scope, $routeParams, $location, $window, $document, $log) {
    //var page = this;
    //console.log('start!', $routeParams.id); return;
    
    $routeParams.id;
    $scope.pageFile = 'app/page/'+$routeParams.id+'.html';
    $scope.onLoad = function(){
     // initHammer();
    };
    
    var minPage = 1;
    var maxPage = 3;
    
    var path = $location.path();
    var currentPage, nextPage, prevPage;
    var currentPage = path.match(/(\d)$/)[1];
    var nextPage = currentPage<maxPage ? Number(currentPage)+1 : maxPage;
    var prevPage = currentPage>minPage ? Number(currentPage)-1 : minPage;
    
    function setPage(pageNum){
      console.log('setPage ',pageNum);
      if (pageNum && pageNum == currentPage){
        return;
      }
      $location.path('/page/'+pageNum);
      $scope.$apply();
      return pageNum;
    }
    
    $scope.setPage = setPage;
    
/*  
    Hamster($window).wheel(function(event, delta, deltaX, deltaY){
    //Hamster(angular.element('.onepage').get(0)).wheel(function(event, delta, deltaX, deltaY){
      console.log(this, event, delta, deltaX, deltaY);
      if(delta>0){
        //$(this).scrollTop() + $(this).innerHeight()>=$(this)[0].scrollHeight
        if(angular.element($window).scrollTop()+angular.element($window).height() == angular.element($document).height()){
          angular.element('.spview').removeClass('slidedown').addClass('slideup');
          setPage(nextPage);
        }
      } else {
        if(angular.element($window).scrollTop()==0){
          angular.element('.spview').removeClass('slideup').addClass('slidedown');
          setPage(prevPage);
        }
      }
    });
*/
   /* function initHammer(){
    $(".onepage").hammer()
      .on('panup', function(ev) {
        console.log('sгз');
        console.log(ev.pointers);
        $(".onepage").scrollTo(ev.pointers);
          setPage(nextPage);
      }).on('pandown', function(ev) {
        $(".onepage").scrollTo(ev.pointers);
        setPage(prevPage);
        console.log(ev.pointers);
         console.log('sdown');
      }).data('hammer')
        .get('swipe')
        .set({ direction: Hammer.DIRECTION_VERTICAL });
      //var mc = new Hammer($("body"));
    }*/

  }
  
})();

(function() {
  'use strict';

  angular
    .module('s5')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, $uibModal) {
    var vm = this;
    
    angular.element('.main-carousel > .carousel-inner').addClass('vertical');
    console.log( angular.element('.main-carousel > .carousel-inner'));

   /* vm.showToastr = showToastr;

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
    }*/
    
    $scope.openModal = function (templateUrl, windowClass) {
      var modalInstance = $uibModal.open({
        templateUrl: templateUrl,
        windowClass: windowClass || 'spModal',
        //size: ''
      });
    };
    
    $scope.isCollapsed = false;
    
    // $scope.lastBabaOver = null;

    $scope.activateBlock = function(num) {
      //return;
      // TweenMax.killAll();
      if(window.innerWidth > 767){
      for (var i = 1; i <= 4; i++) {
        if (i == num) {
          TweenMax.to($(".bb" + num), .5, {
            width: "40%"
          });
        }
        /*else if(i==$scope.lastBabaOver){
                  TweenMax.to($(".bb"+i), .5, {width:"20%"});
                }
                */
        else {
          TweenMax.to($(".bb" + i), .5, {
            width: "20%"
          });
        }
      }
      }
      //$scope.lastBabaOver = num;
    }

    $scope.mout = function() {
      //return;
      if(window.innerWidth > 767){
      for (var i = 1; i <= 4; i++) {
        TweenMax.to($(".bb" + i), .2, {
          width: "25%"
        });
      }
      }
    }
    
    $scope.showSlide = function(num){
      //$rootScope.broadcast("showSlide", {'num':num});
      $scope.$broadcast("showSlide", {'num':num})
    }
    
    function checkBodyResizeClass(){
              if(window.innerWidth < 992){
                $('body').addClass('resize_width');
              }else{
                $('body').removeClass('resize_width');
              }
              
              if(window.innerHeight < 767){
                $('body').addClass('resize_height');
              }else{
                $('body').removeClass('resize_height');
              }
            }
            
            $(window).on('resize', function() {
              checkBodyResizeClass();
            });
checkBodyResizeClass();



  }
})();

(function() {
  'use strict';

  angular
    .module('s5')
    .directive('spArticlesAnons', Directive);

  /** @ngInject */
  function Directive($log, ArticlesListService) {
    var directive = {
      restrict: 'E',
      replace: true,
      scope: {
        item: '=',
        template: '@'
      },
      template: '<ng-include src="getTemplateUrl()"/>',
      controller: Controller
    };

    return directive;

    /** @ngInject */
    function Controller($scope, $element) {
      
      $scope.service = ArticlesListService;
      
      $scope.getTemplateUrl = function() {
        return $scope.item.getPath('fileAnons');
      }
      
      $scope.$on('$destroy', function(){
        //$element.off(animationsHandler)
      });
      
      //debugger;
      //$log.debug($scope, $element);
      
    }
  }

})();

;
(function() {

    'use strict';

    angular.module('s5')
        .service('ArticlesListService', Service)
        .controller('ArticlesListCtrl', ListCtrl)
        .controller('ArticlesDetailCtrl', DetailCtrl);
        
    DetailCtrl.$inject = ['$scope', '$routeParams', '$location', 'ArticlesListService'];

    function DetailCtrl($scope, $routeParams, $location, ArticlesListService) {

        $scope.id = $routeParams.id;
        $scope.service = ArticlesListService;
        $scope.itemsList = $scope.service.getList();
        $scope.item = $scope.service.getElement($scope.id-1);
        
        if (!$scope.item) {
          $location.path("/");
        }
    }
    
    ListCtrl.$inject = ['$scope', 'ArticlesListService'];

    function ListCtrl($scope, ArticlesListService) {
        
        $scope.service = ArticlesListService;
        $scope.itemsList = $scope.service.getList();
        $scope.getExcludeIdFilter = getExcludeIdFilter;
        
        function getExcludeIdFilter(id){
            return function (next){
                return (!id) ? true : next.id != id;
            }
        }
        
    }
    
    Service.$inject = ['$sce'];
  
    function Service($sce)
    {

        var service = {
            getList: getList,
            getElement: getElement,
            trustUrl: trustUrl,
        };
        
        var paths = {
            url: '#/articles/:id',
            fileItem: 'app/articles/html/:id.html',
            fileAnons: 'app/articles/html/anons/:id.html' //anons.html
        };
        
        var list = [
            {
              id: 1,
              name: 'Плохая привычка',
              type: 'current'
          },
          {
              id: 2,
              name: 'Белок молодости',
              type: 'future'
          },
        ];
        
        angular.forEach(list, function(item){
            item.getPath = getPath;
        });
        //debugger;
        
        return service;
        
        function getPath(key, item){
            if(paths.hasOwnProperty(key)){
                return compilePath(paths[key], arguments[1] || this);
            }
            return null;
        }
        
        function compilePath(template, vars){
            return template.replace(/:(\w+)/g, function(s, key){
                return vars[key] || s;
            });
        }
        
        function trustUrl(link){
            $sce.trustAsResourceUrl(link);
        }

        function getList(){
          return list;
        }
        
        function getElement(num){
          return list[num];
        }
  
    }

})();
(function() {
  'use strict';

  angular
    .module('s5')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $location, $anchorScroll) {
   
    $rootScope.showSlide = function(idx){
      $('.main-carousel >  .carousel-indicators li:eq('+idx+')').click();
    };
   
    $rootScope.$on("$viewContentLoaded", function(event) {
      //$rootScope.shareInit();
      $anchorScroll();
      sendGAEvent('ShowScreen', 'Screen ' + $location.path(), 'Экран ' + $location.path());
    });
    //$log.debug('runBlock end');
  }

})();

function sendGAEvent(category, action, label){
  try{
    ga(ga.getAll()[0].get('name')+'.send', 'event', category, action, label);
  }catch(e){
    //console.log('ga error');
  };
}
(function() {
  'use strict';

  angular
    .module('s5')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .when('/page/:id', {
        templateUrl: 'app/page/page-detail.html',
        controller: 'PageController',
        controllerAs: 'page'
      })
      .when('/full/', {
        templateUrl: 'app/main/main.full.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .when('/preview', {
        templateUrl: 'app/main/preview.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .when('/articles/:id', {
        templateUrl: 'app/articles/detail.html',
        controller: 'ArticlesDetailCtrl',
        controllerAs: 'articlesDetail'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

})();

/* jQuery:false */
(function() {
  'use strict';

  angular
    .module('s5')
    .constant('$', jQuery)
    .constant('spSettings', {
      'id': 's5-angular14',
    });

})();

(function() {
  'use strict';

  angular
    .module('s5')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("s5").run(["$templateCache", function($templateCache) {$templateCache.put("app/articles/all.html","<div ng-controller=\"ArticlesListCtrl\"><sp-articles-anons ng-repeat=\"nextItem in itemsList\" item=\"nextItem\" class=\"item{{ $index+1 }}\"></sp-articles-anons></div>");
$templateCache.put("app/articles/detail.html","<sp-navbar></sp-navbar><div class=\"container\"><h1 class=\"content__title\">{{ item.name }}</h1><div class=\"item__content item_{{id}}\"><div ng-include=\"item.getPath(\'fileItem\')\"></div></div><div ng-include=\"\'app/articles/more.html\'\"></div></div><sp-footer></sp-footer>");
$templateCache.put("app/articles/more.html","<div class=\"item-list\" ng-controller=\"ArticlesListCtrl\"><h2 class=\"item-list__title\">Смотрите также</h2><sp-articles-anons ng-repeat=\"nextItem in itemsList | filter:getExcludeIdFilter(item.id)\" item=\"nextItem\" class=\"item{{ $index+1 }}\"></sp-articles-anons></div>");
$templateCache.put("app/main/main.full.html","<div class=\"site_wrap full-height\"><sp-navbar></sp-navbar><div class=\"content_box full-height\"><uib-carousel interval=\"5000\" no-wrap=\"false\" class=\"full-height main-carousel\" template-url=\"app/components/sp-carousel-vertical/carousel-vertical.html\"><uib-slide class=\"full-height\" active=\"slides[0].active\"><div class=\"block1 ff_block\" data-anchor=\"_main\" id=\"main\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12 col-lg-push-4 col-md-push-4 col-sm-push-4\"><img src=\"./assets/images/block1_head.png\" class=\"img-responsive\"><div class=\"btn_box\"><a class=\"btn_go\" href=\"\" ng-click=\"showSlide(1)\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-6 col-lg-pull-4 col-md-pull-4 col-sm-pull-4\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/e59685c8373931bbd73f8f5a470fa9d0\" template=\"rating\" caption=\"Я за прямые волосы\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-6\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f175d835c86a494750c84d82abe1b61f\" template=\"rating\" caption=\"Я за стильные кудри\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div><a href=\"#tipcosmo\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">бьюти-советы редакторов&nbsp;Cosmo</a><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_white\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></uib-slide><uib-slide class=\"full-height\" active=\"slides[1].active\"><div class=\"block2 ff_block\" ng-mouseleave=\"mout()\" data-anchor=\"_tipcosmo\" id=\"tipcosmo\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div><div class=\"baba_block bb1\" ng-mouseover=\"activateBlock(1)\"><div class=\"baba_info baba_1\" ng-click=\"openPopup1 = !openPopup1\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Ольга Шишкина</div><div class=\"hr\"></div><div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div></div></div></div><div class=\"baba_block bb2\" ng-mouseover=\"activateBlock(2)\"><div class=\"baba_info baba_2\" ng-click=\"openPopup2 = !openPopup2\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Нино Такаишвили</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div></div></div></div><div class=\"baba_block bb3\" ng-mouseover=\"activateBlock(3)\"><div class=\"baba_info baba_3\" ng-click=\"openPopup3 = !openPopup3\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Татьяна Катышева</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div></div></div></div><div class=\"baba_block bb4\" ng-mouseover=\"activateBlock(4)\"><div class=\"baba_info baba_4\" ng-click=\"openPopup4 = !openPopup4\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Дарья Королькова</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div></div></div></div><div class=\"clearfix\"></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup1}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup1 = !openPopup1\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_1.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Ольга Шишкина</div><div class=\"hr\"></div><div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div><div class=\"txt\">Не так давно один стилист по волосам сказал мне: \"Идеально прямые волосы идут только 18-летним девушкам\". \"Слишком радикально, но рациональное зерно в этом есть\", – подумала я, посмотрела в зеркало, в паспорт и решила: в мои 23 выпрямленные пряди тоже ничего. Так что танцуй, пока молодой! Добавим сюда экономию времени – 5 минут на укладку <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179084&bid=4186529&bn=4186529&rnd=1591618394\" target=\"_blank\">утюжком Rowenta SF4402</a> против 20 минут на завивку – и вдохновляющие фото с показов (когда-когда вы там в последний раз видели локоны а-ля выпускница-стайл?). Так что мой вердикт: выпрямлять!</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup2}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup2 = !openPopup2\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_2.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Нино Такаишвили</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div><div class=\"txt\">Многие девушки с прямыми волосами постоянно завивают их и мечтают о том, чтобы шевелюра была кудрявой. У меня, если честно, все не так – я всегда была довольна своими прямыми волосами, потому что обращаться с ними намного проще. При желании можно создавать локоны любой формы – от голливудских волн до плотных тугих колечек, можно носить просто гладкие выпрямленные волосы. В обычной жизни я предпочитаю второй вариант, мне кажется, это смотрится стильно. Каждый день я вытягиваю свои волосы <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179086&bid=4186554&bn=4186554&rnd=1707855827\" target=\"_blank\">феном-щеткой Rowenta Brush Activ Volume & Shine</a>, с которой можно легко и быстро сделать пряди идеально гладкими. Щетка вращается автоматически, так что даже делать ничего не нужно. С этим справится любая девушка.</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup3}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup3 = !openPopup3\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_3.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Татьяна Катышева</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div><div class=\"txt\">Когда-то давно я не любила объемные прически, пышные волосы. Но, наверное, тогда я была еще совсем молода. Сейчас кудри для меня сродни маленькому черному платью – подойдут абсолютно ко всему. В моем случае – и к джинсам, и к тяжелым ботинкам, и к элегантному платью. Тем более когда категорически нет времени на сборы. Волны можно легко сделать с помощью <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179087&bid=4186558&bn=4186558&rnd=1958302213\" target=\"_blank\">выпрямителя Rowenta SF7640</a>, вместо того чтобы обжигать пальцы о плойку для завивки. Кстати, объемная прическа визуально меня стройнит, а какой девушке это может не понравиться?</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup4}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup4 = !openPopup4\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_4.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Дарья Королькова</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div><div class=\"txt\">От природы у меня волосы не слишком прямые, но и не кудрявые, поэтому в жизни случались периоды, когда я волосы вытягивала и когда завивала. Честно говоря, с кудрями я себе нравлюсь больше: как ни треплет ветер волосы, все равно получается стильный беспорядок, влажность не превращается в кошмар для укладки, да и в целом образ более задорный. Конечно, навертеть локоны – дольше и труднее, чем вытянуть пряди, поэтому обычно я выбирала между красотой и удобством. Появление <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179085&bid=4186551&bn=4186551&rnd=1210390886\" target=\"_blank\">автоматической плойки So Curls Rowenta</a> проблему полностью разрешило: 5 минут на практику – и теперь на укладку волос у меня уходит от силы 10 минут (это вместе с сушкой феном). Сначала было страшновато, что плойка “зажует” локон, но я убедилась, что все просто и комфортно. Настолько, что после 10 лет с относительно короткой стрижкой я решилась отрастить волосы до лопаток, и вот уже год не стригусь. Хочу посмотреть, как будут получаться локоны на длинных волосах.</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div></div></uib-slide><uib-slide class=\"full-height\" active=\"slides[2].active\"><div class=\"block3 ff_block\" data-anchor=\"_about\" id=\"about\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 col-lg-offset-1 col-md-5 col-md-offset-0 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0\"><img src=\"./assets/images/block3_img.png\" class=\"img-responsive\"></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 text-center\"><div class=\"head\">Независимо от&nbsp;выбранного образа, тебе не&nbsp;обойтись без&nbsp;хорошего фена.</div><div class=\"txt\">Качественно высушить волосы, не перегревая и не повреждая их, поможет фен <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179088&bid=4186562&bn=4186562&rnd=374091057\" target=\"_blank\">Rowenta CV 7670</a>. Он не только оснащен керамической решеткой нагревательного элемента, функциями ионизации и турборежима. У фена есть уникальная функция Silence, благодаря которой прибор работает удивительно тихо. Ты можешь укладывать волосы даже посреди ночи, никого не разбудив!</div></div></div></div></div></div><a href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">Участвуй!</a><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div></uib-slide><uib-slide class=\"full-height\" active=\"slides[3].active\"><div class=\"block4 ff_block\" data-anchor=\"_steps\" id=\"steps\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"header\">Участвуй!</div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"steps_box\"><div class=\"steps_content step1\"><div class=\"circle_step\">1</div><div class=\"spet_txt\">Вступи в группы <a href=\"http://vk.com/cosmopolitan\" target=\"_blank\">Cosmo</a> и <a href=\"http://vk.com/rowentafb\" target=\"_blank\">Rowenta</a> “ВКонтакте”.</div></div><div class=\"steps_content step2\"><div class=\"circle_step\">2</div><div class=\"spet_txt\">Сделай репост о конкурсе себе на стену.</div></div><div class=\"steps_content step3\"><div class=\"circle_step\">3</div><div class=\"spet_txt\">Загрузи фото в альбом <a href=\"http://vk.com/album-25523033_224491911\" target=\"_blank\">Straight</a> или <a href=\"http://vk.com/album-25523033_224491916\" target=\"_blank\">Curl</a> в группе Rowenta.</div></div><div class=\"steps_content step4\"><div class=\"circle_step\">4</div><div class=\"spet_txt\">Дождись, когда модератор группы опубликует твой пост.</div></div><div class=\"steps_content step5\"><div class=\"circle_step\">5</div><div class=\"spet_txt\">Приглашай друзей делать репосты, добавляя кодовую фразу ”Голосую за... (твои имя и фамилия), желаю победы с #Rowenta!”</div></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-5 col-xs-12 col-lg-offset-0 col-md-offset-0 col-sm-offset-1 col-xs-offset-0\"><div class=\"b_box\"><div class=\"ico_gift\"></div><div class=\"info\">Призы достанутся как авторам самого эффектного снимка, так и набравшим максимальное количество репостов.</div><a class=\"btn_open_popup\" ng-click=\"openPopup5 = !openPopup5\">Кстати, о призах!</a></div></div><div class=\"col-lg-3 col-md-4 col-sm-5 col-xs-12\"><div id=\"vk_groups\"></div><script type=\"text/javascript\">\n                                        VK.Widgets.Group(\"vk_groups\", {\n                                            mode: 0,\n                                            width: \"263\",\n                                            height: \"252\",\n                                            color1: \'424f5e\',\n                                            color2: \'ffffff\',\n                                            color3: \'00aed1\'\n                                        }, 25523033);\n                                    </script></div></div></div></div></div><a href=\"#tipsite\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">Cоветы по&nbsp;укладке волос</a><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_white\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup5}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><a href=\"\" ng-click=\"openPopup5 = !openPopup5\" class=\"btn_close_popup\"></a></div></div></div><div class=\"gifts_info\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"header\">Кстати, о призах!</div></div></div><div class=\"row text-center\"><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-12\"><div class=\"p_h\">4 главных<br>приза</div><div class=\"hr\"></div><div class=\"info\">Это шикарные наборы Rowenta, состоящие из: автоматической плойки для волос So Curls, премиального фена CV7670, премиального выпрямителя SF7640, зеркала для макияжа MR4700, ванночки для ног TS8051, премиального утюга DW9230 и увлажнителя воздуха HU5115. Победителей выберет жюри со стороны Cosmo.ru и Rowenta.</div></div><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12\"><div class=\"p_h\">4 приза третьего уровня</div><div class=\"hr\"></div><div class=\"info\">Замечательные наборы, состоящие из: автоматической плойки для волос So Curls, фена CV6080, выпрямителя SF4402 и утюга DW5122. Победителей выберет бьюти-блогер Limfina</div></div><div class=\"clearfix visible-sm\"></div><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-12\"><div class=\"p_h\">4 приза второго уровня</div><div class=\"hr\"></div><div class=\"info\">Наборы Rowenta, состоящие из: автоматической плойки для волос So Curls, фена Respectissim CV7430 и выпрямителя CF7196. Победители будут определены по большему числу репостов записи с кодовой фразой.</div></div><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12\"><div class=\"p_h\">А также 4 поощрительных приза</div><div class=\"hr\"></div><div class=\"info\">Наборы из автоматической плойки для волос So Curls и увлажнителя воздуха HU5115. Победители в этой номинации определятся случайным образом с помощью важных или памятных чисел для бренда Rowenta и Cosmo.ru (числа сохраняются в тайне до самого конца акции).</div></div></div></div></div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></uib-slide><uib-slide class=\"full-height\" active=\"slides[4].active\"><div class=\"block5 ff_block\" data-anchor=\"_tipsite\" id=\"tipsite\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"header\">Cоветы по укладке волос</div></div></div><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 col-xs-offset-0\"><uib-carousel class=\"slider_box\" interval=\"5000\" no-wrap=\"false\"><uib-slide active=\"true\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide1.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179090&bid=4186564&bn=4186564&rnd=336395832\" target=\"_blank\">Фен Rowenta CV 6080</a> может похвастаться профессиональным АС-мотором, развивающим мощность до 2100 Вт. А концентратор фена имеет уникальное строение – внутри находится подвижный элемент, который при включении начинает рассеивать воздух с большим покрытием. Используя щетку-брашинг, ты можешь создать эффектный прикорневой объем и даже слегка накрутить волосы. Все это проще простого!</p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179090&bid=4186564&bn=4186564&rnd=336395832\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide2.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179091&bid=4186566&bn=4186566&rnd=267335074\" target=\"_blank\">Фен Rowenta Respectissim Pro CV7430</a> это быстрая сушка без вреда для волос. Температура 65°С защищает волосы от перегрева, а скорость подачи воздуха 15 м/с уменьшает повреждения волос. Приятные бонусы – ионизация и ЖК-дисплей. Поэкспериментируй с активным диффузором. Он не только создает объем у корней, приподнимая их во время сушки. Движущиеся пальчики также массируют кожу головы, улучшая кровообращение и способствуя росту волос.</p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179091&bid=4186566&bn=4186566&rnd=267335074\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide3.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179092&bid=4186568&bn=4186568&rnd=1069939850\" target=\"_blank\">Выпрямитель для волос Rowenta Styling Art CF7196</a> обладает всем необходимым для создания укладки твоей мечты. Хочешь безупречную гладкость? Керамическое покрытие, ионизация и быстрый нагрев максимально облегчат задачу. Очаровательные кудри? Стайлер способен и на это! Выбери температуру от 130°С до 210°С и сформируй модные локоны.</p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179092&bid=4186568&bn=4186568&rnd=1069939850\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide4.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179093&bid=4186585&bn=4186585&rnd=1735225540\" target=\"_blank\">Утюг DW9230</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179093&bid=4186585&bn=4186585&rnd=1735225540\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide5.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179094&bid=4186596&bn=4186596&rnd=1666285694\" target=\"_blank\">Утюг DW5122</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179094&bid=4186596&bn=4186596&rnd=1666285694\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide6.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179095&bid=4186644&bn=4186644&rnd=1369220362\" target=\"_blank\">Увлажнитель HU5115</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179095&bid=4186644&bn=4186644&rnd=1369220362\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide7.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179096&bid=4186649&bn=4186649&rnd=2133624016\" target=\"_blank\">Зеркало для макияжа Mr4700</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179096&bid=4186649&bn=4186649&rnd=2133624016\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide8.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179097&bid=4186673&bn=4186673&rnd=1550159298\" target=\"_blank\">Ванночки для ног TS8051</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179097&bid=4186673&bn=4186673&rnd=1550159298\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide></uib-carousel></div></div></div></div></div><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div></uib-slide></uib-carousel></div><sp-footer></sp-footer></div>");
$templateCache.put("app/main/main.html","<div class=\"site_wrap\"><sp-navbar></sp-navbar><script type=\"text/ng-template\" id=\"modal-priz.html\"><!--div class=\"modal-header text-right\"> <a href=\"\" ng-click=\"$close()\"> <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span> </a> </div--> <div class=\"modal-body\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"> <a href=\"\" ng-click=\"$close()\" class=\"btn_close_popup\"></a> </div> </div> </div> <div class=\"gifts_info\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"> <div class=\"header\">Кстати, о призах!</div> </div> </div> <div class=\"row text-center\"> <div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-12\"> <div class=\"p_h\">4 главных<br/> приза</div> <div class=\"hr\"></div> <div class=\"info\">Это шикарные наборы Rowenta, состоящие из: автоматической плойки для волос So Curls, премиального фена CV7670, премиального выпрямителя SF7640, зеркала для макияжа MR4700, ванночки для ног TS8051, премиального утюга DW9230 и увлажнителя воздуха HU5115. Победителей выберет жюри со стороны Cosmo.ru и Rowenta.</div> </div> <div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12\"> <div class=\"p_h\">4 приза третьего уровня</div> <div class=\"hr\"></div> <div class=\"info\">Замечательные наборы, состоящие из: автоматической плойки для волос So Curls, фена CV6080, выпрямителя SF4402 и утюга DW5122. Победителей выберет бьюти-блогер Limfina</div> </div> <div class=\"clearfix visible-sm\"></div> <div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-12\"> <div class=\"p_h\">4 приза второго уровня</div> <div class=\"hr\"></div> <div class=\"info\">Наборы Rowenta, состоящие из: автоматической плойки для волос So Curls, фена Respectissim CV7430 и выпрямителя CF7196. Победители будут определены по большему числу репостов записи с кодовой фразой.</div> </div> <div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12\"> <div class=\"p_h\">А также 4 поощрительных приза</div> <div class=\"hr\"></div> <div class=\"info\">Наборы из автоматической плойки для волос So Curls и увлажнителя воздуха HU5115. Победители в этой номинации определятся случайным образом с помощью важных или памятных чисел для бренда Rowenta и Cosmo.ru (числа сохраняются в тайне до самого конца акции).</div> </div> </div> </div> </div> <div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div> </div></script><script type=\"text/ng-template\" id=\"modal-art1.html\"><!--div class=\"modal-header text-right\"> <a href=\"\" ng-click=\"$close()\"> <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span> </a> </div--> <div class=\"modal-body\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <!--a href=\"\" ng-click=\"openPopup1 = !openPopup1\" class=\"btn_close_popup\"></a--> <a href=\"\" ng-click=\"$close()\" class=\"btn_close_popup\"> <!--span class=\"glyphicon glyphicon-remove\" class=\"btn_close_popup\" aria-hidden=\"true\"></span--> </a> </div> </div> </div> <div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_1.jpg\" class=\"img-responsive\" /></div> <div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"> <div class=\"header girl_name\">Ольга Шишкина</div> <div class=\"hr\"></div> <div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div> <div class=\"txt\">Не так давно один стилист по волосам сказал мне: \"Идеально прямые волосы идут только 18-летним девушкам\". \"Слишком радикально, но рациональное зерно в этом есть\", – подумала я, посмотрела в зеркало, в паспорт и решила: в мои 23 выпрямленные пряди тоже ничего. Так что танцуй, пока молодой! Добавим сюда экономию времени – 5 минут на укладку <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179084&bid=4186529&bn=4186529&rnd=1591618394\" target=\"_blank\">утюжком Rowenta SF4402</a> против 20 минут на завивку – и вдохновляющие фото с показов (когда-когда вы там в последний раз видели локоны а-ля выпускница-стайл?). Так что мой вердикт: выпрямлять!</div> <div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div> </div> </div> </div> </div> </div> </div></div> </div></script><script type=\"text/ng-template\" id=\"modal-art2.html\"><div class=\"modal-body\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <a href=\"\" ng-click=\"$close()\" class=\"btn_close_popup\"> <!--span class=\"glyphicon glyphicon-remove\" class=\"btn_close_popup\" aria-hidden=\"true\"></span--> </a> </div> </div> </div> <div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_2.jpg\" class=\"img-responsive\" /></div> <div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"> <div class=\"header girl_name\">Нино Такаишвили</div> <div class=\"hr\"></div> <div class=\"who\">Редактор Cosmo.ru</div> <div class=\"txt\">Многие девушки с прямыми волосами постоянно завивают их и мечтают о том, чтобы шевелюра была кудрявой. У меня, если честно, все не так – я всегда была довольна своими прямыми волосами, потому что обращаться с ними намного проще. При желании можно создавать локоны любой формы – от голливудских волн до плотных тугих колечек, можно носить просто гладкие выпрямленные волосы. В обычной жизни я предпочитаю второй вариант, мне кажется, это смотрится стильно. Каждый день я вытягиваю свои волосы <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179086&bid=4186554&bn=4186554&rnd=1707855827\" target=\"_blank\">феном-щеткой Rowenta Brush Activ Volume & Shine</a>, с которой можно легко и быстро сделать пряди идеально гладкими. Щетка вращается автоматически, так что даже делать ничего не нужно. С этим справится любая девушка.</div> <div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div> </div> </div> </div> </div> </div> </div></div> </div></script><script type=\"text/ng-template\" id=\"modal-art3.html\"><div class=\"modal-body\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <a href=\"\" ng-click=\"$close()\" class=\"btn_close_popup\"> <!--span class=\"glyphicon glyphicon-remove\" class=\"btn_close_popup\" aria-hidden=\"true\"></span--> </a> </div> </div> </div> <div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_3.jpg\" class=\"img-responsive\" /></div> <div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"> <div class=\"header girl_name\">Татьяна Катышева</div> <div class=\"hr\"></div> <div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div> <div class=\"txt\">Когда-то давно я не любила объемные прически, пышные волосы. Но, наверное, тогда я была еще совсем молода. Сейчас кудри для меня сродни маленькому черному платью – подойдут абсолютно ко всему. В моем случае – и к джинсам, и к тяжелым ботинкам, и к элегантному платью. Тем более когда категорически нет времени на сборы. Волны можно легко сделать с помощью <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179087&bid=4186558&bn=4186558&rnd=1958302213\" target=\"_blank\">выпрямителя Rowenta SF7640</a>, вместо того чтобы обжигать пальцы о плойку для завивки. Кстати, объемная прическа визуально меня стройнит, а какой девушке это может не понравиться?</div> <div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div> </div> </div> </div> </div> </div> </div></div> </div></script><script type=\"text/ng-template\" id=\"modal-art4.html\"><div class=\"modal-body\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <a href=\"\" ng-click=\"$close()\" class=\"btn_close_popup\"> <!--span class=\"glyphicon glyphicon-remove\" class=\"btn_close_popup\" aria-hidden=\"true\"></span--> </a> </div> </div> </div> <div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"> <div class=\"container\"> <div class=\"row\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_4.jpg\" class=\"img-responsive\" /></div> <div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"> <div class=\"header girl_name\">Дарья Королькова</div> <div class=\"hr\"></div> <div class=\"who\">Редактор Cosmo.ru</div> <div class=\"txt\">От природы у меня волосы не слишком прямые, но и не кудрявые, поэтому в жизни случались периоды, когда я волосы вытягивала и когда завивала. Честно говоря, с кудрями я себе нравлюсь больше: как ни треплет ветер волосы, все равно получается стильный беспорядок, влажность не превращается в кошмар для укладки, да и в целом образ более задорный. Конечно, навертеть локоны – дольше и труднее, чем вытянуть пряди, поэтому обычно я выбирала между красотой и удобством. Появление <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179085&bid=4186551&bn=4186551&rnd=1210390886\" target=\"_blank\">автоматической плойки So Curls Rowenta</a> проблему полностью разрешило: 5 минут на практику – и теперь на укладку волос у меня уходит от силы 10 минут (это вместе с сушкой феном). Сначала было страшновато, что плойка “зажует” локон, но я убедилась, что все просто и комфортно. Настолько, что после 10 лет с относительно короткой стрижкой я решилась отрастить волосы до лопаток, и вот уже год не стригусь. Хочу посмотреть, как будут получаться локоны на длинных волосах.</div> <div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div> </div> </div> </div> </div> </div> </div></div> </div></script><div class=\"content_box\"><ul class=\"page-indicators\"><li><a href=\"#main\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#tipcosmo\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#about\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#tipsite\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li></ul><div class=\"f_page\" sp-fullpage=\"\"><div class=\"block1 ff_block\" data-anchor=\"_main\" id=\"main\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12 col-lg-push-4 col-md-push-4 col-sm-push-4\"><img src=\"./assets/images/block1_head.png\" class=\"img-responsive\"><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-6 col-lg-pull-4 col-md-pull-4 col-sm-pull-4\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/e59685c8373931bbd73f8f5a470fa9d0\" template=\"rating\" caption=\"Я за прямые волосы\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-6\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f175d835c86a494750c84d82abe1b61f\" template=\"rating\" caption=\"Я за стильные кудри\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div><a href=\"#tipcosmo\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">бьюти-советы редакторов&nbsp;Cosmo</a><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_white\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div><div class=\"block2 ff_block\" ng-mouseleave=\"mout()\" data-anchor=\"_tipcosmo\" id=\"tipcosmo\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div><div class=\"baba_block bb1\" ng-mouseover=\"activateBlock(1)\"><div class=\"baba_info baba_1\" ng-click=\"openModal(\'modal-art1.html\', \'spModal\')\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Ольга Шишкина</div><div class=\"hr\"></div><div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div></div></div></div><div class=\"baba_block bb2\" ng-mouseover=\"activateBlock(2)\"><div class=\"baba_info baba_2\" ng-click=\"openModal(\'modal-art2.html\', \'spModal\')\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Нино Такаишвили</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div></div></div></div><div class=\"baba_block bb3\" ng-mouseover=\"activateBlock(3)\"><div class=\"baba_info baba_3\" ng-click=\"openModal(\'modal-art3.html\', \'spModal\')\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Татьяна Катышева</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div></div></div></div><div class=\"baba_block bb4\" ng-mouseover=\"activateBlock(4)\"><div class=\"baba_info baba_4\" ng-click=\"openModal(\'modal-art4.html\', \'spModal\')\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Дарья Королькова</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div></div></div></div><div class=\"clearfix\"></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup1}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup1 = !openPopup1\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_1.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Ольга Шишкина</div><div class=\"hr\"></div><div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div><div class=\"txt\">Не так давно один стилист по волосам сказал мне: \"Идеально прямые волосы идут только 18-летним девушкам\". \"Слишком радикально, но рациональное зерно в этом есть\", – подумала я, посмотрела в зеркало, в паспорт и решила: в мои 23 выпрямленные пряди тоже ничего. Так что танцуй, пока молодой! Добавим сюда экономию времени – 5 минут на укладку <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179084&bid=4186529&bn=4186529&rnd=1591618394\" target=\"_blank\">утюжком Rowenta SF4402</a> против 20 минут на завивку – и вдохновляющие фото с показов (когда-когда вы там в последний раз видели локоны а-ля выпускница-стайл?). Так что мой вердикт: выпрямлять!</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup2}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup2 = !openPopup2\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_2.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Нино Такаишвили</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div><div class=\"txt\">Многие девушки с прямыми волосами постоянно завивают их и мечтают о том, чтобы шевелюра была кудрявой. У меня, если честно, все не так – я всегда была довольна своими прямыми волосами, потому что обращаться с ними намного проще. При желании можно создавать локоны любой формы – от голливудских волн до плотных тугих колечек, можно носить просто гладкие выпрямленные волосы. В обычной жизни я предпочитаю второй вариант, мне кажется, это смотрится стильно. Каждый день я вытягиваю свои волосы <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179086&bid=4186554&bn=4186554&rnd=1707855827\" target=\"_blank\">феном-щеткой Rowenta Brush Activ Volume & Shine</a>, с которой можно легко и быстро сделать пряди идеально гладкими. Щетка вращается автоматически, так что даже делать ничего не нужно. С этим справится любая девушка.</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup3}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup3 = !openPopup3\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_3.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Татьяна Катышева</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div><div class=\"txt\">Когда-то давно я не любила объемные прически, пышные волосы. Но, наверное, тогда я была еще совсем молода. Сейчас кудри для меня сродни маленькому черному платью – подойдут абсолютно ко всему. В моем случае – и к джинсам, и к тяжелым ботинкам, и к элегантному платью. Тем более когда категорически нет времени на сборы. Волны можно легко сделать с помощью <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179087&bid=4186558&bn=4186558&rnd=1958302213\" target=\"_blank\">выпрямителя Rowenta SF7640</a>, вместо того чтобы обжигать пальцы о плойку для завивки. Кстати, объемная прическа визуально меня стройнит, а какой девушке это может не понравиться?</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup4}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup4 = !openPopup4\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_4.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Дарья Королькова</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div><div class=\"txt\">От природы у меня волосы не слишком прямые, но и не кудрявые, поэтому в жизни случались периоды, когда я волосы вытягивала и когда завивала. Честно говоря, с кудрями я себе нравлюсь больше: как ни треплет ветер волосы, все равно получается стильный беспорядок, влажность не превращается в кошмар для укладки, да и в целом образ более задорный. Конечно, навертеть локоны – дольше и труднее, чем вытянуть пряди, поэтому обычно я выбирала между красотой и удобством. Появление <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179085&bid=4186551&bn=4186551&rnd=1210390886\" target=\"_blank\">автоматической плойки So Curls Rowenta</a> проблему полностью разрешило: 5 минут на практику – и теперь на укладку волос у меня уходит от силы 10 минут (это вместе с сушкой феном). Сначала было страшновато, что плойка “зажует” локон, но я убедилась, что все просто и комфортно. Настолько, что после 10 лет с относительно короткой стрижкой я решилась отрастить волосы до лопаток, и вот уже год не стригусь. Хочу посмотреть, как будут получаться локоны на длинных волосах.</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div></div><div class=\"block3 ff_block\" data-anchor=\"_about\" id=\"about\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 col-lg-offset-1 col-md-5 col-md-offset-0 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0\"><img src=\"./assets/images/block3_img.png\" class=\"img-responsive\"></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 text-center\"><div class=\"head\">Независимо от&nbsp;выбранного образа, тебе не&nbsp;обойтись без&nbsp;хорошего фена.</div><div class=\"txt\">Качественно высушить волосы, не перегревая и не повреждая их, поможет фен <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179088&bid=4186562&bn=4186562&rnd=374091057\" target=\"_blank\">Rowenta CV 7670</a>. Он не только оснащен керамической решеткой нагревательного элемента, функциями ионизации и турборежима. У фена есть уникальная функция Silence, благодаря которой прибор работает удивительно тихо. Ты можешь укладывать волосы даже посреди ночи, никого не разбудив!</div></div></div></div></div></div><a href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">Участвуй!</a><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div><div class=\"block4 ff_block\" data-anchor=\"_steps\" id=\"steps\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"header\">Участвуй!</div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"steps_box\"><div class=\"steps_content step1\"><div class=\"circle_step\">1</div><div class=\"spet_txt\">Вступи в группы <a href=\"http://vk.com/cosmopolitan\" target=\"_blank\">Cosmo</a> и <a href=\"http://vk.com/rowentafb\" target=\"_blank\">Rowenta</a> “ВКонтакте”.</div></div><div class=\"steps_content step2\"><div class=\"circle_step\">2</div><div class=\"spet_txt\">Сделай репост о конкурсе себе на стену.</div></div><div class=\"steps_content step3\"><div class=\"circle_step\">3</div><div class=\"spet_txt\">Загрузи фото в альбом <a href=\"http://vk.com/album-25523033_224491911\" target=\"_blank\">Straight</a> или <a href=\"http://vk.com/album-25523033_224491916\" target=\"_blank\">Curl</a> в группе Rowenta.</div></div><div class=\"steps_content step4\"><div class=\"circle_step\">4</div><div class=\"spet_txt\">Дождись, когда модератор группы опубликует твой пост.</div></div><div class=\"steps_content step5\"><div class=\"circle_step\">5</div><div class=\"spet_txt\">Приглашай друзей делать репосты, добавляя кодовую фразу ”Голосую за... (твои имя и фамилия), желаю победы с #Rowenta!”</div></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-5 col-xs-12 col-lg-offset-0 col-md-offset-0 col-sm-offset-1 col-xs-offset-0\"><div class=\"b_box\"><div class=\"ico_gift\"></div><div class=\"info\">Призы достанутся как авторам самого эффектного снимка, так и набравшим максимальное количество репостов.</div><a href=\"\" class=\"btn_open_popup\" ng-click=\"openModal(\'modal-priz.html\', \'spModal\')\">Кстати, о призах!</a></div></div><div class=\"col-lg-3 col-md-4 col-sm-5 col-xs-12\"><div id=\"vk_groups\"></div><script type=\"text/javascript\">\n                            VK.Widgets.Group(\"vk_groups\", {mode: 0, width: \"263\", height: \"252\", color1: \'424f5e\', color2: \'ffffff\', color3: \'00aed1\'}, 25523033);\n                            </script></div></div></div></div></div><a href=\"#tipsite\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">Cоветы по&nbsp;укладке волос</a><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_white\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup5}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><a href=\"\" ng-click=\"openPopup5 = !openPopup5\" class=\"btn_close_popup\"></a></div></div></div><div class=\"gifts_info\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"header\">Кстати, о призах!</div></div></div><div class=\"row text-center\"><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-12\"><div class=\"p_h\">4 главных<br>приза</div><div class=\"hr\"></div><div class=\"info\">Это шикарные наборы Rowenta, состоящие из: автоматической плойки для волос So Curls, премиального фена CV7670, премиального выпрямителя SF7640, зеркала для макияжа MR4700, ванночки для ног TS8051, премиального утюга DW9230 и увлажнителя воздуха HU5115. Победителей выберет жюри со стороны Cosmo.ru и Rowenta.</div></div><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12\"><div class=\"p_h\">4 приза третьего уровня</div><div class=\"hr\"></div><div class=\"info\">Замечательные наборы, состоящие из: автоматической плойки для волос So Curls, фена CV6080, выпрямителя SF4402 и утюга DW5122. Победителей выберет бьюти-блогер Limfina</div></div><div class=\"clearfix visible-sm\"></div><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-12\"><div class=\"p_h\">4 приза второго уровня</div><div class=\"hr\"></div><div class=\"info\">Наборы Rowenta, состоящие из: автоматической плойки для волос So Curls, фена Respectissim CV7430 и выпрямителя CF7196. Победители будут определены по большему числу репостов записи с кодовой фразой.</div></div><div class=\"col-lg-3 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12\"><div class=\"p_h\">А также 4 поощрительных приза</div><div class=\"hr\"></div><div class=\"info\">Наборы из автоматической плойки для волос So Curls и увлажнителя воздуха HU5115. Победители в этой номинации определятся случайным образом с помощью важных или памятных чисел для бренда Rowenta и Cosmo.ru (числа сохраняются в тайне до самого конца акции).</div></div></div></div></div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div><div class=\"block5 ff_block\" data-anchor=\"_tipsite\" id=\"tipsite\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"header\">Призовой фонд</div></div></div><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 col-xs-offset-0\"><uib-carousel class=\"slider_box\" interval=\"5000\" no-wrap=\"false\"><uib-slide active=\"true\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide1.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179090&bid=4186564&bn=4186564&rnd=336395832\" target=\"_blank\">Фен Rowenta CV 6080</a> может похвастаться профессиональным АС-мотором, развивающим мощность до 2100 Вт. А концентратор фена имеет уникальное строение – внутри находится подвижный элемент, который при включении начинает рассеивать воздух с большим покрытием. Используя щетку-брашинг, ты можешь создать эффектный прикорневой объем и даже слегка накрутить волосы. Все это проще простого!</p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179090&bid=4186564&bn=4186564&rnd=336395832\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide2.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179091&bid=4186566&bn=4186566&rnd=267335074\" target=\"_blank\">Фен Rowenta Respectissim Pro CV7430</a> это быстрая сушка без вреда для волос. Температура 65°С защищает волосы от перегрева, а скорость подачи воздуха 15 м/с уменьшает повреждения волос. Приятные бонусы – ионизация и ЖК-дисплей. Поэкспериментируй с активным диффузором. Он не только создает объем у корней, приподнимая их во время сушки. Движущиеся пальчики также массируют кожу головы, улучшая кровообращение и способствуя росту волос.</p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179091&bid=4186566&bn=4186566&rnd=267335074\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide3.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179092&bid=4186568&bn=4186568&rnd=1069939850\" target=\"_blank\">Выпрямитель для волос Rowenta Styling Art CF7196</a> обладает всем необходимым для создания укладки твоей мечты. Хочешь безупречную гладкость? Керамическое покрытие, ионизация и быстрый нагрев максимально облегчат задачу. Очаровательные кудри? Стайлер способен и на это! Выбери температуру от 130°С до 210°С и сформируй модные локоны.</p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179092&bid=4186568&bn=4186568&rnd=1069939850\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide4.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179093&bid=4186585&bn=4186585&rnd=1735225540\" target=\"_blank\">Утюг DW9230</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179093&bid=4186585&bn=4186585&rnd=1735225540\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide5.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179094&bid=4186596&bn=4186596&rnd=1666285694\" target=\"_blank\">Утюг DW5122</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179094&bid=4186596&bn=4186596&rnd=1666285694\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide6.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179095&bid=4186644&bn=4186644&rnd=1369220362\" target=\"_blank\">Увлажнитель HU5115</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179095&bid=4186644&bn=4186644&rnd=1369220362\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide7.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179096&bid=4186649&bn=4186649&rnd=2133624016\" target=\"_blank\">Зеркало для макияжа Mr4700</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179096&bid=4186649&bn=4186649&rnd=2133624016\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide><uib-slide active=\"false\"><div class=\"slide_item\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_img\"><img src=\"./assets/images/slide8.png\" class=\"img-responsive\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"slide_txt\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><p><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179097&bid=4186673&bn=4186673&rnd=1550159298\" target=\"_blank\">Ванночки для ног TS8051</a></p><div class=\"btn_box\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179097&bid=4186673&bn=4186673&rnd=1550159298\" target=\"_blank\" class=\"btn_go\"><span data-hover=\"Купить\">Купить</span></a></div></div></div></div></div></div></div></uib-slide></uib-carousel></div></div></div></div></div><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div></div></div><sp-footer></sp-footer></div>");
$templateCache.put("app/main/preview.html","<div class=\"container\"><sp-navbar></sp-navbar><hr><p class=\"bg-primary text-center clearfix\">превью тостера</p><p class=\"text-center\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><hr><p class=\"bg-primary text-center clearfix\">пошер</p><div sp-share=\"http://sp.cosmo.ru/\" class=\"investigation-block__share social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div><hr><p class=\"bg-primary text-center clearfix\">каунтер</p><div class=\"timer text-center\" sp-countdown=\"2030-11-04 12:00:00\"><div class=\"day\"><span class=\"up_box\">{{countdown.timer.days}}</span> <span class=\"bot_box\">{{countdown.lang.days}}</span></div><div class=\"hours\"><span class=\"up_box\">{{countdown.timer.hours}}</span> <span class=\"bot_box\">{{countdown.lang.hours}}</span></div><div class=\"minutes\"><span class=\"up_box\">{{countdown.timer.minutes}}</span> <span class=\"bot_box\">{{countdown.lang.minutes}}</span></div><div class=\"seconds\"><span class=\"up_box\">{{countdown.timer.seconds}}</span> <span class=\"bot_box\">{{countdown.lang.seconds}}</span></div><div class=\"clearfix\"></div></div><hr><p class=\"bg-primary text-center clearfix\">статьи</p><div ng-include=\"\'app/articles/all.html\'\"></div><hr><p class=\"bg-primary text-center clearfix\">форма фотоконкурса</p><div sp-form=\"23\" template=\"form\"></div><p class=\"bg-primary text-center clearfix\">фотоконкурс</p><div sp-profiles-results=\"{{showProfilesResult}}\" template=\"list\" limit=\"1\"></div><hr><p class=\"bg-primary text-center clearfix\">форма вопросов эксперту</p><div sp-form=\"24\" template=\"form\"></div><hr><p class=\"bg-primary text-center clearfix\">вопросы эксперту</p><div sp-experts-results=\"{{showExpertsResult}}\" template=\"list\" limit=\"1\"></div><hr><p class=\"bg-primary text-center clearfix\">инстаграм</p><div sp-instagram-list=\"cosmospecialpro\" template=\"list\" limit=\"1\"></div><hr><p class=\"bg-primary text-center clearfix\">превью сладера</p><div ng-controller=\"ArticlesListCtrl\"><div style=\"height: 90px\"><uib-carousel interval=\"5000\" no-wrap=\"false\"><uib-slide ng-repeat=\"nextItem in itemsList\" active=\"$first\"><a ng-href=\"http://sp.popmech.ru/gereports/{{ nextItem.getPath(\'url\') }}\" target=\"_blank\"><img ng-src=\"http://dummyimage.com/728x90/292929/e3e3e3?text=assets/images/start/{{ nextItem.type }}.jpg\" style=\"margin:auto;\"></a><div class=\"carousel-caption\"><a ng-href=\"{{ nextItem.getPath(\'url\') }}\" target=\"_blank\"><h4>Slide {{$index}}</h4><p>{{nextItem.name}}</p></a></div></uib-slide></uib-carousel></div></div><hr><p class=\"bg-primary text-center clearfix\">превью теста</p><sp-simple-test></sp-simple-test><hr><p class=\"bg-primary text-center clearfix\">фулскринайзер</p>link:https://github.com/brandly/angular-youtube-embed<fullscreenizer></fullscreenizer><sp-footer></sp-footer></div>");
$templateCache.put("app/page/1.html","<div class=\"onepage page1\" sp-pagechange=\"setPage\" page-prev=\"1\" page-next=\"2\"><div class=\"block1 ff_block\" data-anchor=\"_main\" id=\"main\"><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12 col-lg-push-4 col-md-push-4 col-sm-push-4\"><img src=\"./assets/images/block1_head.png\" class=\"img-responsive\"><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-6 col-lg-pull-4 col-md-pull-4 col-sm-pull-4\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/e59685c8373931bbd73f8f5a470fa9d0\" template=\"rating\" caption=\"Я за прямые волосы\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-6\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f175d835c86a494750c84d82abe1b61f\" template=\"rating\" caption=\"Я за стильные кудри\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div><a href=\"#tipcosmo\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">бьюти-советы редакторов&nbsp;Cosmo</a><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/3b4c2d8ccfa77f907b43c326935b6726\" class=\"social_white\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div>");
$templateCache.put("app/page/2.html","<div class=\"onepage page2\" sp-pagechange=\"setPage\" page-prev=\"1\" page-next=\"3\"><div class=\"block2 ff_block\" ng-mouseleave=\"mout()\" data-anchor=\"_tipcosmo\" id=\"tipcosmo\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div><div class=\"baba_block bb1\" ng-mouseover=\"activateBlock(1)\"><div class=\"baba_info baba_1\" ng-click=\"openPopup1 = !openPopup1\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Ольга Шишкина</div><div class=\"hr\"></div><div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div></div></div></div><div class=\"baba_block bb2\" ng-mouseover=\"activateBlock(2)\"><div class=\"baba_info baba_2\" ng-click=\"openPopup2 = !openPopup2\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Нино Такаишвили</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div></div></div></div><div class=\"baba_block bb3\" ng-mouseover=\"activateBlock(3)\"><div class=\"baba_info baba_3\" ng-click=\"openPopup3 = !openPopup3\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Татьяна Катышева</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div></div></div></div><div class=\"baba_block bb4\" ng-mouseover=\"activateBlock(4)\"><div class=\"baba_info baba_4\" ng-click=\"openPopup4 = !openPopup4\"><div class=\"opacity_bg\"></div><div class=\"about_baba\"><div class=\"name\">Дарья Королькова</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div></div></div></div><div class=\"clearfix\"></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup1}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup1 = !openPopup1\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_1.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Ольга Шишкина</div><div class=\"hr\"></div><div class=\"who\">Старший редактор Cosmopolitan Beauty, старший редактор раздела красоты Cosmopolitan Shopping</div><div class=\"txt\">Не так давно один стилист по волосам сказал мне: \"Идеально прямые волосы идут только 18-летним девушкам\". \"Слишком радикально, но рациональное зерно в этом есть\", – подумала я, посмотрела в зеркало, в паспорт и решила: в мои 23 выпрямленные пряди тоже ничего. Так что танцуй, пока молодой! Добавим сюда экономию времени – 5 минут на укладку <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179084&bid=4186529&bn=4186529&rnd=1591618394\" target=\"_blank\">утюжком Rowenta SF4402</a> против 20 минут на завивку – и вдохновляющие фото с показов (когда-когда вы там в последний раз видели локоны а-ля выпускница-стайл?). Так что мой вердикт: выпрямлять!</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup2}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup2 = !openPopup2\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_2.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Нино Такаишвили</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div><div class=\"txt\">Многие девушки с прямыми волосами постоянно завивают их и мечтают о том, чтобы шевелюра была кудрявой. У меня, если честно, все не так – я всегда была довольна своими прямыми волосами, потому что обращаться с ними намного проще. При желании можно создавать локоны любой формы – от голливудских волн до плотных тугих колечек, можно носить просто гладкие выпрямленные волосы. В обычной жизни я предпочитаю второй вариант, мне кажется, это смотрится стильно. Каждый день я вытягиваю свои волосы <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179086&bid=4186554&bn=4186554&rnd=1707855827\" target=\"_blank\">феном-щеткой Rowenta Brush Activ Volume & Shine</a>, с которой можно легко и быстро сделать пряди идеально гладкими. Щетка вращается автоматически, так что даже делать ничего не нужно. С этим справится любая девушка.</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup3}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup3 = !openPopup3\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_3.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Татьяна Катышева</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmopolitan Beauty, редактор раздела красоты Cosmopolitan Shopping</div><div class=\"txt\">Когда-то давно я не любила объемные прически, пышные волосы. Но, наверное, тогда я была еще совсем молода. Сейчас кудри для меня сродни маленькому черному платью – подойдут абсолютно ко всему. В моем случае – и к джинсам, и к тяжелым ботинкам, и к элегантному платью. Тем более когда категорически нет времени на сборы. Волны можно легко сделать с помощью <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179087&bid=4186558&bn=4186558&rnd=1958302213\" target=\"_blank\">выпрямителя Rowenta SF7640</a>, вместо того чтобы обжигать пальцы о плойку для завивки. Кстати, объемная прическа визуально меня стройнит, а какой девушке это может не понравиться?</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div><div class=\"popup_box\" ng-class=\"{\'open-popup\': openPopup4}\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><a href=\"\" ng-click=\"openPopup4 = !openPopup4\" class=\"btn_close_popup\"></a></div></div></div><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><img src=\"./assets/images/poeople_4.jpg\" class=\"img-responsive\"></div><div class=\"col-lg-6 col-md-8 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-0 col-sm-offset-0 col-xs-offset-0\"><div class=\"header\">Дарья Королькова</div><div class=\"hr\"></div><div class=\"who\">Редактор Cosmo.ru</div><div class=\"txt\">От природы у меня волосы не слишком прямые, но и не кудрявые, поэтому в жизни случались периоды, когда я волосы вытягивала и когда завивала. Честно говоря, с кудрями я себе нравлюсь больше: как ни треплет ветер волосы, все равно получается стильный беспорядок, влажность не превращается в кошмар для укладки, да и в целом образ более задорный. Конечно, навертеть локоны – дольше и труднее, чем вытянуть пряди, поэтому обычно я выбирала между красотой и удобством. Появление <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179085&bid=4186551&bn=4186551&rnd=1210390886\" target=\"_blank\">автоматической плойки So Curls Rowenta</a> проблему полностью разрешило: 5 минут на практику – и теперь на укладку волос у меня уходит от силы 10 минут (это вместе с сушкой феном). Сначала было страшновато, что плойка “зажует” локон, но я убедилась, что все просто и комфортно. Настолько, что после 10 лет с относительно короткой стрижкой я решилась отрастить волосы до лопаток, и вот уже год не стригусь. Хочу посмотреть, как будут получаться локоны на длинных волосах.</div><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/f7de0073ee84dc48a524f7239dac6e05\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/page/3.html","<div class=\"onepage page3\" sp-pagechange=\"setPage\" page-prev=\"2\" page-next=\"3\"><div class=\"block3 ff_block\" data-anchor=\"_about\" id=\"about\"><a target=\"_blank\" class=\"mini_logo\"></a><div class=\"tbl_disp\"><div class=\"tbl_disp_cell\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 col-lg-offset-1 col-md-5 col-md-offset-0 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0\"><img src=\"./assets/images/block3_img.png\" class=\"img-responsive\"></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 text-center\"><div class=\"head\">Независимо от&nbsp;выбранного образа, тебе не&nbsp;обойтись без&nbsp;хорошего фена.</div><div class=\"txt\">Качественно высушить волосы, не перегревая и не повреждая их, поможет фен <a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179088&bid=4186562&bn=4186562&rnd=374091057\" target=\"_blank\">Rowenta CV 7670</a>. Он не только оснащен керамической решеткой нагревательного элемента, функциями ионизации и турборежима. У фена есть уникальная функция Silence, благодаря которой прибор работает удивительно тихо. Ты можешь укладывать волосы даже посреди ночи, никого не разбудив!</div></div></div></div></div></div><a href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\" class=\"btn_next\">Участвуй!</a><div class=\"btn_box\"><a class=\"btn_go\" href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"><span data-hover=\"Участвуй!\">Участвуй!</span></a></div></div></div>");
$templateCache.put("app/page/page-detail.html","<div class=\"site_wrap\" style=\"height:100%\"><sp-navbar></sp-navbar><div class=\"content_box\" style=\"height:100%\"><ul class=\"page-indicators\"><li><a href=\"#main\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#tipcosmo\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#about\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li><li><a href=\"#tipsite\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></li></ul><div ng-include=\"pageFile\" onload=\"onLoad()\" style=\"height:100%\"></div></div><sp-footer></sp-footer></div>");
$templateCache.put("app/articles/html/1.html","{{item}}<h1>Статья 1</h1><p>Душа моя озарена неземной радостью, как эти чудесные весенние утра, которыми я наслаждаюсь от всего сердца. Я совсем один и блаженствую в здешнем краю, словно созданном для таких, как я.</p><p>Я так счастлив, мой друг, так упоен ощущением покоя, что искусство мое страдает от этого. Ни одного штриха не мог бы я сделать, а никогда не был таким большим художником, как в эти минуты.</p>");
$templateCache.put("app/articles/html/2.html","{{item}}<h1>Статья 2</h1><p>Когда от милой моей долины поднимается пар и полдневное солнце стоит над непроницаемой чащей темного леса и лишь редкий луч проскальзывает в его святая святых, а я лежу в высокой траве у быстрого ручья и, прильнув к земле, вижу тысячи всевозможных былинок и чувствую, как близок моему сердцу крошечный мирок, что снует между стебельками, наблюдаю эти неисчислимые, непостижимые разновидности червяков и мошек и чувствую близость всемогущего, создавшего нас по своему подобию, веяние вселюбящего, судившего нам парить в вечном блаженстве, когда взор мой туманится и все вокруг меня и небо надо мной запечатлены в моей душе, точно образ возлюбленной, - тогда, дорогой друг, меня часто томит мысль: \"Ах!</p>");
$templateCache.put("app/components/sp-carousel-vertical/carousel-vertical.html","<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\"><div class=\"carousel-inner vertical\" ng-transclude=\"\"></div><a role=\"button\" href=\"\" class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span> <span class=\"sr-only\">previous</span></a> <a role=\"button\" href=\"\" class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span> <span class=\"sr-only\">next</span></a><ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\"><li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\"><span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span></li></ol></div>");
$templateCache.put("app/components/sp-experts-results/results-list.html","<h3 ng-click=\"updatePage(1)\">Вопросы</h3><div class=\"comment_box\" ng-repeat=\"result in results | orderBy:\'-result.TIMESTAMP\'\"><div class=\"quest\"><div class=\"quest_head\"><img src=\"http://dummyimage.com/30x30/292929/e3e3e3?text=АФТАР\"> {{ result.DATA.NICKNAME[0].USER_TEXT }}</div><div class=\"quest_txt\">{{ result.DATA.TEXT[0].USER_TEXT }}</div></div><div class=\"answer\" ng-if=\"result.DATA.EXPERT[0].USER_TEXT\"><blockquote><div class=\"answer_head\"><img src=\"http://dummyimage.com/30x30/292929/e3e3e3?text=ЭКСПЕРТ\"> Эксперт</div><div class=\"answer_txt\">{{ result.DATA.EXPERT[0].USER_TEXT }}</div></blockquote></div><hr></div><a href=\"\" ng-click=\"mediaMore()\" ng-show=\"currentPage < numPages && !loading\" class=\"btn_more media-experts-list-more\" sp-scroll-to=\"+600\">загрузить еще</a><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"totalItems\" items-per-page=\"itemsPerPage\" ng-model=\"currentPage\" ng-change=\"pageChanged()\" max-size=\"maxSize\" num-pages=\"numPages\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div>");
$templateCache.put("app/components/sp-footer/footer.html","<div class=\"footer\"><a ng-click=\"openFooter = !openFooter\" class=\"btn_open_footer footer-open btn_toggle\" ng-class=\"{\'open-footer\': openFooter}\"></a><div class=\"magic_foot\" ng-class=\"{\'open-footer\': openFooter}\"><div class=\"hidden_footer\" ng-class=\"{\'open-footer\': openFooter}\"><div class=\"footer_bg\"><div class=\"sp_footer container-fluid\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"row footer_box\"><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-6\"><a href=\"http://imedia.ru/\" target=\"_blank\"><div class=\"logo_foot\"></div></a></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-6 col-sm-push-6 col-md-push-6 col-lg-push-8\"><div class=\"contact_box\"><span class=\"glyphicon glyphicon-map-marker\"></span> <a href=\"http://www.imedia.ru/about/contacts/\" target=\"_blank\">Контактная<br>информация</a></div></div><div class=\"col-lg-8 col-md-6 col-sm-6 col-xs-12 col-sm-pull-3 col-md-pull-3 col-lg-pull-2 text-center\"><p>Не смогли разобраться с чем-то? Есть вопросы?<br>Напишите письмо, и мы вам ответим: <a href=\"mailto:spsupport.contest@imedia.ru\">spsupport.contest@imedia.ru</a></p></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/sp-form/form.html","<div class=\"spanketa\"><div class=\"thanks\" style=\"display: none\">Спасибо, результат сохранен!</div><div class=\"validation\"></div><div class=\"anketa\"></div></div>");
$templateCache.put("app/components/sp-instagram/list.html","<h3>Instagram #{{tag}}</h3><div class=\"instagram-list clearfix\"><a ng-repeat=\"photo in media | orderBy:\'-photo.created_time\'\" target=\"_blank\" ng-href=\"{{ photo.link }}\" data-likes=\"{{ photo.likes.count }}\"><div class=\"opacity_bg transition_all_inst\"></div><div class=\"info transition_all_inst\"><span class=\"full_name\">{{ photo.user.full_name }}</span> <span class=\"username\">@{{ photo.user.username }}</span> <span class=\"likes\"><i class=\"glyphicon glyphicon-heart-empty\"></i> {{ photo.likes.count }}</span></div><img class=\"link img-responsive transition_all_inst\" ng-src=\"{{ photo.images.standard_resolution.url }}\" data-url=\"{{ photo.link }}\" alt=\"\"></a></div><a href=\"\" ng-click=\"mediaMore()\" ng-show=\"max_id>0 && !loading\" class=\"media-instagram-more\">Больше фото</a>");
$templateCache.put("app/components/sp-navbar/navbar.html","<nav class=\"navbar navbar-default navbar-fixed-top\" ng-class=\"{active: !isCollapsed}\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-3\"><a class=\"btn_menu_open\" ng-class=\"{active: !isCollapsed}\" ng-click=\"isCollapsed = !isCollapsed\">МЕНЮ</a></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-5\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179082&bid=4186521&bn=4186521&rnd=744841908\" target=\"_blank\"><img src=\"./assets/images/logo_sp.png\" class=\"img-responsive logo_sp\"></a></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-4\"><a href=\"http://ad.adriver.ru/cgi-bin/click.cgi?sid=1&ad=552593&bt=2&pid=2179083&bid=4186522&bn=4186522&rnd=1438487188\" target=\"_blank\"><img src=\"./assets/images/logo_cosmo.png\" class=\"img-responsive logo_cosmo\"></a></div></div></div><div uib-collapse=\"isCollapsed\"><ul class=\"top_menu\"><li><a href=\"#main\" du-smooth-scroll=\"\" du-scrollspy=\"\">Straight vs Curl. Битва причесок</a></li><li><a href=\"#tipcosmo\" du-smooth-scroll=\"\" du-scrollspy=\"\">Бьюти-советы редакторов Cosmo</a></li><li><a href=\"#about\" du-smooth-scroll=\"\" du-scrollspy=\"\">Флагманский продукт Rowenta</a></li><li><a href=\"#steps\" du-smooth-scroll=\"\" du-scrollspy=\"\">Участвуй!</a></li><li><a href=\"#tipsite\" du-smooth-scroll=\"\" du-scrollspy=\"\">Призовой фонд</a></li></ul></div></nav>");
$templateCache.put("app/components/sp-profiles-results/results-list.html","<h3 ng-click=\"updatePage(1)\">Участники</h3><div class=\"profiles-list clearfix\"><a ng-repeat=\"result in results | orderBy:\'-result.TIMESTAMP\'\" href=\"\" ng-click=\"showProfile(result)\" sp-scroll-to=\".profile\"><div class=\"opacity_bg transition_all_profiles\"></div><div class=\"info transition_all_profiles\"><span class=\"full_name\">{{ result.DATA.NICKNAME[0].USER_TEXT }}</span></div><img class=\"link img-responsive transition_all_profiles\" ng-src=\"{{ result.DATA.PHOTO[0].IMAGE.HOST }}{{ result.DATA.PHOTO[0].IMAGE.CROP }}\"></a></div><a href=\"\" ng-click=\"mediaMore()\" ng-show=\"currentPage < numPages && !loading\" class=\"media-profiles-list-more\" sp-scroll-to=\"+300\">Больше фото</a><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"totalItems\" items-per-page=\"itemsPerPage\" ng-model=\"currentPage\" ng-change=\"pageChanged()\" max-size=\"maxSize\" num-pages=\"numPages\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div><div ng-if=\"profile\" class=\"profile\"><div class=\"row\"><h3 class=\"text-center\">Профайл</h3><div class=\"col-lg-6 col-lg-offset-1 col-md-6 col-md-offset-1 col-sm-7 col-sm-offset-0 col-xs-12\"><img class=\"btn img-responsive transition_all_profiles\" data-toggle=\"modal\" data-target=\".profile-preview\" ng-src=\"{{ profile.DATA.PHOTO[0].IMAGE.HOST }}{{ profile.DATA.PHOTO[0].IMAGE.CROP }}\"></div><div class=\"col-lg-4 col-md-4 col-sm-5 col-xs-12\"><div class=\"user_info_box\"><span class=\"full_name\">{{ profile.DATA.NICKNAME[0].USER_TEXT }}</span><p class=\"for_like text-center\"><small>Голос = шер! Поделись этим фото в соцсети, чтобы проголосовать за участницу.</small></p><div sp-share=\"{{profileShareLink}}\" caption=\"Голосовать\" class=\"social_black\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div><div class=\"modal fade profile-preview\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-llg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\"><span class=\"full_name\">{{ profile.DATA.NICKNAME[0].USER_TEXT }}</span></h4></div><div class=\"modal-body text-center\"><img class=\"link img-responsive transition_all_profiles\" ng-src=\"{{ profile.DATA.PHOTO[0].IMAGE.HOST }}{{ profile.DATA.PHOTO[0].IMAGE.FIT }}\"></div></div></div></div></div>");
$templateCache.put("app/components/sp-share/rating.html","<a class=\"vote_box\"><div class=\"vote_num wrap\">{{count}}</div><div class=\"vote_txt social_txt\">{{caption}}</div><div class=\"social_btns\" style=\"display:none\"></div></a>");
$templateCache.put("app/components/sp-share/share.html","<div class=\"social {{class}}\"><div class=\"social_txt\"><div class=\"caption\">{{caption}}</div><div class=\"wrap\">{{count}}</div></div><div class=\"social_btns\" style=\"display:none\"></div></div>");
$templateCache.put("app/components/sp-simple-test/test.html","<div class=\"test-block__screen _active test-init\" ng-show=\"state==\'promo\'\"><div class=\"container\"><h2 class=\"test-init__title\">Проверь, как себя<br>чувствует твоя кожа?</h2><button class=\"teset-init__button button\" ng-click=\"startTest()\">Начать тест</button><div class=\"test-block__share-container center-block\"><div sp-share=\"http://sp.cosmo.ru/api/common/share/go/25b77ccd25d01d02aa396d427479fd5e\" class=\"social_purple\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div><div class=\"test-block__screen test-question _active\" ng-class=\"{\'superquestion\': curQuestionNum == 1}\" ng-show=\"state==\'course\'\"><div class=\"container\"><p class=\"test-question__content\">Стартовая цифра – это твой биологический возраст. Выбери фразы, подходящие твоей внешности и образу жизни, и прибавь или отними соответствующие им цифры от стартовой.</p><div class=\"test-question__head\">{{ curQuestion.quest }}</div><div class=\"test-question__subhead\">{{ curQuestion.subhead }}</div><div class=\"test-question__options\"><button class=\"test-question__option button\" ng-repeat=\"answer in curQuestion.answers\" ng-click=\"setActive($event)\">{{answer.text}}</button></div><div class=\"text-center\"><div class=\"test-question__next-button\" ng-click=\"showNext()\">Следующий вопрос</div></div></div></div><div class=\"test-block__screen test-result {{\'_result\'+(resultNum+1)}}\" ng-show=\"state==\'result\'\"><div class=\"container\"><div class=\"test-result__two-pearls two-pearls\"><img src=\"assets/images/two-pearls.png\"></div><div class=\"test-result__title\">{{ results[resultNum].head }}</div><p class=\"test-result__text\">{{ results[resultNum].text }}</p><div class=\"test-form\" ng-hide=\"mailSended || mailError\"><div class=\"test-form__title\">Хочешь получить персональную программу ухода за кожей<br>от бьюти-эксперта? Оставь свой e-mail и в течение 15 минут жди программу!</div><form method=\"POST\" ng-submit=\"sendMail()\"><input placeholder=\"Твой Email\" class=\"test-form__input i-text\" type=\"email\" name=\"email\" ng-model=\"user.mail\" required=\"\"><div class=\"test-form__submit i-submit\">Получить программу <input type=\"submit\" value=\"Submit\"></div></form></div><div class=\"test-result__thanks test-thanks\" ng-show=\"mailSended\"><div class=\"test-thanks__message\">Программа была отправлена на указанный email!</div></div><div class=\"test-result__thanks test-thanks\" ng-show=\"mailError\"><div class=\"test-thanks__message\">Ошибка, повторите ввод</div></div><div class=\"test-result__precaution\">*Данный тест носит ориентировочный характер, для получения полной информации о состоянии вашей кожи и перед применением рекомендаций по уходу за собой проконсультируйтесь со специалистом.</div><div class=\"test-block__share-container center-block\"><div sp-share=\"{{ results[resultNum].link }}\" class=\"social_white\" services=\"vkontakte,facebook,twitter\" type=\"small\" theme=\"counter\"></div></div></div></div>");
$templateCache.put("app/articles/html/anons/1.html","<a ng-href=\"{{item.getPath(\'url\')}}\" class=\"type-{{item.type}}\"><h1>{{item.name}}</h1><div class=\"animashki\"><img class=\"img-responsive\" ng-src=\"http://dummyimage.com/200x200/292929/e3e3e3?text=assets/{{ item.id }}.jpg\"></div></a>");
$templateCache.put("app/articles/html/anons/2.html","<a ng-href=\"{{item.getPath(\'url\')}}\" class=\"type-{{item.type}}\"><h1>{{item.name}}</h1><div class=\"animashki\"><img class=\"img-responsive\" ng-src=\"http://dummyimage.com/200x200/292929/e3e3e3?text=assets/{{ item.id }}.jpg\"></div></a>");}]);